
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fTmNK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $55fM8 = parcelRequire("55fM8");


var $1UWNP = parcelRequire("1UWNP");


var $lzgC6 = parcelRequire("lzgC6");


var $I7hWB = parcelRequire("I7hWB");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $b9k8w = parcelRequire("b9k8w");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $9GVkD = parcelRequire("9GVkD");


var $9XB2W = parcelRequire("9XB2W");


var $cFVPs = parcelRequire("cFVPs");


var $lpJCW = parcelRequire("lpJCW");


var $4tOXV = parcelRequire("4tOXV");


var $1k6sE = parcelRequire("1k6sE");


var $aK0Eq = parcelRequire("aK0Eq");


var $7aRa9 = parcelRequire("7aRa9");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7mpOv = parcelRequire("7mpOv");


var $kycWk = parcelRequire("kycWk");

var $iuuqT = parcelRequire("iuuqT");

var $2MwVI = parcelRequire("2MwVI");


var $1ggpj = parcelRequire("1ggpj");


var $9wGTI = parcelRequire("9wGTI");


var $8m9SI = parcelRequire("8m9SI");


var $i0AJ7 = parcelRequire("i0AJ7");


var $idaAv = parcelRequire("idaAv");


var $fazoG = parcelRequire("fazoG");


var $2SWmG = parcelRequire("2SWmG");

// The duration is hard-coded in styled bc compiled css will not allow us to insert this timing dynamically. It's also slightly longer to account for easing out
const $90aadbae3b7b5d0e$var$ERROR_ANIMATION_DURATION = 1200;
const $90aadbae3b7b5d0e$export$f5770e9cb651fcf2 = 255;
const $90aadbae3b7b5d0e$export$46429ae68bc65284 = 'Cannot send metadata, currently offline.';
const $90aadbae3b7b5d0e$var$i18n = (0, $kSwu1.defineMessages)({
    blogpostTitlePlaceholder: {
        id: "editor-title.existing.blogpost.placeholder",
        defaultMessage: "Blog post title"
    },
    editorOnboardingExpTitlePlaceholderText: {
        id: "editor-title.editor.onboarding.title.placeholder",
        defaultMessage: "Give this page a title"
    },
    aiGeneratedTitleDismissButton: {
        id: "editor-title.ai.title.error.dismiss",
        defaultMessage: "Dismiss"
    },
    aiGeneratedTitleFromPaste: {
        id: "editor-title.flags.generate.ai.from.paste.title",
        defaultMessage: "AI generated a title for this page"
    },
    aiGeneratedTitleFromPasteDescription: {
        id: "editor-title.flags.generate.ai.from.paste.description",
        defaultMessage: "Rovo generated a title for this page using the content pasted into the editor. <Link>Content quality may vary.</Link>"
    },
    createBlogpostTitleDescription: {
        id: "editor-title.description.add.blogpost",
        defaultMessage: ", Add Blog Post"
    },
    editPageTitleDescription: {
        id: "editor-title.description.edit.page",
        defaultMessage: ", Edit"
    },
    createPageTitleDescription: {
        id: "editor-title.description.add.page",
        defaultMessage: ", Add Page"
    },
    createPageTemplateTitleDescription: {
        id: "editor-title.description.add.page.template",
        defaultMessage: ", Create template"
    },
    editPageTemplateTitleDescription: {
        id: "editor-title.description.edit.page.template",
        defaultMessage: ", Edit template"
    },
    untitledPage: {
        id: "editor-title.untitled.page",
        defaultMessage: "Untitled"
    }
});
const $90aadbae3b7b5d0e$export$aafacd47ca4852d = {
    'data-ai-suggest-title-target': 'true'
};
const $90aadbae3b7b5d0e$var$AIBorderStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface'
});
const $90aadbae3b7b5d0e$var$PlaceholderStyles = (0, $buxP3.xcss)({
    // Necessary for proper editor content/title alignment
    marginTop: 'space.negative.075',
    marginBottom: 'space.050'
});
const $90aadbae3b7b5d0e$var$TitleGenerationPlaceholder = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.200"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.025"
    }));
};
$90aadbae3b7b5d0e$var$TitleGenerationPlaceholder.displayName = 'TitleGenerationPlaceholder';
const $90aadbae3b7b5d0e$export$ca74a9f12ee60773 = ()=>{
    // we manually expose here: next/packages/editor-title/src/editorTitleStyled.tsx line ~160
    if (!(0, $6mKj3.expValEquals)('platform_editor_editor_title_field_sizing', 'variant', 'test')) return false;
    return (0, $idaAv.isFieldSizingSupported)();
};
/**
 * @todo CTE-268 typing in title is slow with in-editor templates (long term solution)
 * For now, we are solving this by debouncing calls to the onChange prop. Once the long term
 * solution is ready (see ticket for details), we should remove the debounceOnChange prop and logic
 */ class $90aadbae3b7b5d0e$var$EditorTitleComponentClass extends (0, $cozmU.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.title !== state.prevTitle) return {
            title: props.title,
            prevTitle: props.title
        };
        return null;
    }
    componentDidMount() {
        const { isTemplateEditor: isTemplateEditor, title: title } = this.props;
        const { shouldFocusTitle: shouldFocusTitle } = this.state;
        const shouldTemplateEditorTitleFocus = isTemplateEditor && !title && shouldFocusTitle;
        if (shouldTemplateEditorTitleFocus) this._focusTextarea();
        this._updateHeightAuto();
        window.addEventListener('resize', this._onWindowResize);
    }
    componentDidUpdate(prevProps, prevState) {
        const { userOffline: userOffline, focusEditor: focusEditor, title: title, isInPreview: isInPreview, flagArray: flagArray, suppressTitleFocus: suppressTitleFocus } = this.props;
        const { focusChanged: focusChanged, shouldFocusTitle: shouldFocusTitle } = this.state;
        const userWasOffline = prevProps.userOffline && !userOffline;
        const userWasNotOffline = !prevProps.userOffline && !userOffline;
        this._updateHeightAuto();
        if (prevState.prevTitle !== title) {
            this._debouncedOnChange.cancel();
            if (!suppressTitleFocus && (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) // Don't refocus the title if this prop update came from manual user editing.
            {
                if (!this._isManualTitleChange) {
                    this._focusTextarea();
                    // Don't add to undo stack if the change came from manual user editing
                    // Add the previous title so we can undo back to it
                    if (title) this._undoRedoManager.addToUndoStack(title);
                }
            }
            this._isManualTitleChange = false;
        }
        if (userWasOffline) {
            if (focusChanged && shouldFocusTitle) this._focusTextarea();
            else focusEditor();
        }
        if (userWasNotOffline && !title && shouldFocusTitle && !suppressTitleFocus) this._focusTextarea();
        /** Focus title if title-related error flag:
     * We check the flags array length against that of the flags from prevProps so that
     * we can detect if a new error flag has been added. If the current length is greater
     * than the previous length, a flag was added.
     */ if (flagArray && prevProps.flagArray && flagArray.length > prevProps.flagArray.length && (this._hasTitleError() || String(flagArray[0].title) === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE)) this._onTitleError();
        if (prevProps.title === title && prevProps.isInPreview === isInPreview) return;
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize); // cleanup event listener
        this._debouncedOnChange.flush();
        if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) this._undoRedoManager.clear();
    }
    _focusTextarea() {
        if (this._textareaRef.current) this._textareaRef.current.focus();
    }
    _updateHeightAuto() {
        // if the browser doesn't support `field-sizing: content`,
        // this needs to run to set the height of the textarea
        if (!$90aadbae3b7b5d0e$export$ca74a9f12ee60773()) {
            if (this._textareaRef.current) {
                // this line will make a reflow so that `textArea.scrollHeight` is updated with correct value.
                this._textareaRef.current.style.height = 'auto';
                this._textareaRef.current.style.height = `${this._textareaRef.current.scrollHeight}px`;
            }
        }
    }
    render() {
        const { isDisabled: isDisabled, isTitleCenterAligned: isTitleCenterAligned, isAIEnabledForContent: isAIEnabledForContent, isDisabledTextBlack: isDisabledTextBlack } = this.props;
        // We store local changes in state when we debounce calls to this.props.onChange.
        // So state contains the most updated title value in this case
        const title = this.props.debounceOnChange ? this.state.title : this.props.title;
        const description = this.generateDescription();
        const placeholder = this._getTitlePlaceholder();
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(window.__SSR_RENDERED__);
        const UseEditorTextAreaNext = $90aadbae3b7b5d0e$export$ca74a9f12ee60773() ? (0, $8m9SI.EditorTitleTextAreaNext) : (0, $8m9SI.EditorTitleTextArea);
        const EditorTitleTextAreaToUse = isAIEnabledForContent && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_title_generation', 'cohort', 'test') ? (0, $8m9SI.AIGeneratedEditorTitleTextArea) : UseEditorTextAreaNext;
        if (this.state.isTitleGenerating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $90aadbae3b7b5d0e$var$PlaceholderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
            loading: true,
            useModalStyles: true,
            hideGlow: true,
            customInnerContainerStyles: $90aadbae3b7b5d0e$var$AIBorderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90aadbae3b7b5d0e$var$TitleGenerationPlaceholder, null)));
        const editorTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i0AJ7.EditorTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "xlarge"
        }, title || this.props.intl.formatMessage($90aadbae3b7b5d0e$var$i18n.untitledPage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorTitleTextAreaToUse, {
            name: "editpages-title",
            "data-test-id": "editor-title",
            ...$90aadbae3b7b5d0e$export$aafacd47ca4852d,
            maxLength: $90aadbae3b7b5d0e$export$f5770e9cb651fcf2,
            "aria-label": placeholder,
            "aria-describedby": "editor-title-description",
            placeholder: placeholder,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $1k6sE.ALLOW_SHORTCUTS_CLASS),
            value: title || '',
            required: true,
            rows: 1,
            ref: this._textareaRef,
            onKeyDown: this._onKeyDown,
            onChange: this._onTitleChange,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            "data-gramm": false,
            disabled: isDisabled,
            shouldAnimate: this.state.shouldAnimateTitle,
            isTitleAIGenerated: this.state.isTitleAIGenerated,
            isTitleCenterAligned: isTitleCenterAligned,
            isDisabledTextBlack: isDisabledTextBlack,
            key: this.state.shouldAnimateTitle ? 'editor-title-animated' : 'editor-title'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            hidden: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
            id: "editor-title-description",
            testId: "editor-title-description"
        }, description)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isSSR ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fazoG.TitleGenerationOnPaste), {
            contentId: this.props.contentId,
            contentType: this.props.contentType,
            textAreaRef: this._textareaRef,
            title: this.props.title ?? undefined,
            isLivePage: false,
            isEditorEmpty: this.props.isEditorEmpty ?? false,
            userOffline: this.props.userOffline ?? false,
            flags: this.props.flags,
            i18n: $90aadbae3b7b5d0e$var$i18n,
            formatMessage: this.props.intl.formatMessage,
            onTitleGenerated: this._setTitleAI,
            onTitleGeneratingChange: this.props.onTitleGeneratingChange
        }), (0, $9wGTI.fg)('cc-dlp-fix-regressed-redactions-spotlight-tour') ? this.props.renderMigratedRedactionsSpotlight(editorTitle) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION
        }, editorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, this.props.activeRedactionsSpotlight ?? null)));
    }
    constructor(props){
        super(props);
        this._textareaRef = void 0;
        this._hasEditEventFiredRef = void 0;
        this._undoRedoManager = void 0;
        this.state = {
            title: this.props.title,
            // eslint-disable-next-line react/no-unused-state
            prevTitle: this.props.title,
            shouldFocusTitle: this.props.initialShouldFocusTitle ?? true,
            focusChanged: false,
            shouldAnimateTitle: false,
            isTitleAIGenerated: false,
            isTitleGenerating: false
        };
        this._isManualTitleChange = false;
        /**
     * Checks if the flags array has a title-relevant error
     * 1. empty title / title with only whitespace
     * 2. duplicate title
     */ this._hasTitleError = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))(()=>{
            const { flagArray: flagArray, intl: intl } = this.props;
            // These flag messages are always defined so they shouldn't return null
            const titleErrors = [
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title,
                (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]: true
                    },
                    formatMessage: intl.formatMessage
                })?.title
            ];
            if (flagArray && flagArray.length > 0) {
                // We only want to check the most recent, incoming error in case user hasn't dismissed a previous error
                const errorMessage = String(flagArray[0].title);
                return titleErrors.includes(errorMessage);
            }
            return false;
        });
        this._debouncedOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((value)=>{
            this.props.onChange(value);
        }, (0, $1ggpj.onChangeTitleDebounceTime));
        this._onTitleChange = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, spaceId: spaceId } = this.props;
            const newTitle = event.target.value;
            // Mark this as a manual title change so we don't add to undo stack
            this._isManualTitleChange = true;
            this.setState({
                title: newTitle,
                isTitleAIGenerated: false
            });
            if (this.props.debounceOnChange) this._debouncedOnChange(newTitle);
            else this.props.onChange(newTitle);
            if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) this._undoRedoManager.clear();
            if (!this._hasEditEventFiredRef.current) {
                createAnalyticsEvent?.({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'editorTitle',
                        action: 'edited',
                        actionSubject: 'editor',
                        objectId: contentId,
                        objectType: 'page',
                        attributes: {
                            isLivePage: false,
                            editorSessionId: this.props.editorSessionId
                        },
                        containerType: 'space',
                        containerId: spaceId
                    }
                }).fire();
                this._hasEditEventFiredRef.current = true;
            }
        };
        this._onFocusChanged = (focusChanged)=>{
            this.setState({
                shouldFocusTitle: focusChanged,
                focusChanged: true
            });
            this.props.onFocusChanged(focusChanged);
        };
        this._setTitleAI = (newTitle)=>{
            this.setState({
                isTitleGenerating: false,
                title: newTitle,
                isTitleAIGenerated: true
            });
            this.props.onChange(newTitle);
        };
        this._undoAIGeneratedTitle = ()=>{
            const { title: title } = this.state;
            const currentTitle = title || '';
            const previousState = this._undoRedoManager.undo(currentTitle);
            if (currentTitle === previousState) return;
            this.setState({
                title: previousState,
                isTitleAIGenerated: false,
                prevTitle: title
            });
            this.props.onChange(previousState);
        };
        this._redoAIGeneratedTitle = ()=>{
            const { title: title } = this.state;
            const currentTitle = title || '';
            const nextState = this._undoRedoManager.redo(currentTitle);
            if (currentTitle === nextState) return;
            this.setState({
                title: nextState,
                isTitleAIGenerated: false,
                prevTitle: title
            });
            this.props.onChange(nextState);
        };
        this.generateTitle = ()=>{
            const { trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIInteractionInit: trackAIInteractionInit, contentType: contentType, setGeneratedTitle: setGeneratedTitle, setTrackAIResultViewStored: setTrackAIResultViewStored, experienceTracker: experienceTracker, userOffline: userOffline, flags: flags, intl: intl } = this.props;
            if (userOffline) return;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const filteredProseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]'));
            const targetEditorId = filteredProseMirrors[0]?.dataset?.editorId;
            const handleAiTitleError = ({ errorMessage: errorMessage, errorCode: errorCode = 500 })=>{
                this._setTitleAI('');
                trackAIResultError({
                    aiErrorMessage: errorMessage,
                    aiErrorCode: errorCode
                }, {
                    attributes: {
                        contentType: contentType
                    }
                });
                if (errorMessage === $90aadbae3b7b5d0e$export$46429ae68bc65284) // Abort rather than fail because the editor being offline
                // should not be attributed to AI Title Generation experience failure
                experienceTracker.abort({
                    name: (0, $irVI7.AI_TITLE_GENERATION),
                    reason: 'Editor offline'
                });
                else experienceTracker.fail({
                    name: (0, $irVI7.AI_TITLE_GENERATION),
                    error: new Error(errorMessage)
                });
                this.setState({
                    isTitleGenerating: false
                });
                const errorFlagMessage = (0, $cHfGW.buildEditorFlagMessage)({
                    errorData: {
                        [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]: true
                    },
                    formatMessage: intl.formatMessage
                });
                flags.hideFlag('ai-generated-title-flag');
                flags.showErrorFlag({
                    id: 'ai-generated-title-error-flag',
                    title: errorFlagMessage?.title,
                    description: errorFlagMessage?.description,
                    actions: [
                        {
                            content: intl.formatMessage($90aadbae3b7b5d0e$var$i18n.aiGeneratedTitleDismissButton),
                            onClick: ()=>flags.hideFlag('ai-generated-title-error-flag')
                        }
                    ]
                });
            };
            let generatedTitle = '';
            if (targetEditorId) {
                trackAIInteractionInit({
                    attributes: {
                        contentType: contentType
                    }
                });
                setTrackAIResultViewStored?.(trackAIResultView);
                experienceTracker.start({
                    name: (0, $irVI7.AI_TITLE_GENERATION)
                });
                (0, $9XB2W.eventHub).publishToEditor({
                    event: 'start prompt',
                    data: {
                        targetEditorId: targetEditorId,
                        analyticSourceId: 'confluenceTitleGenOnPublish',
                        prompt: 'suggest title',
                        hideModal: true,
                        streamingCallback: (data)=>{
                            switch(data.type){
                                case 'initialising':
                                    this.setState({
                                        isTitleGenerating: true
                                    });
                                    break;
                                case 'streaming':
                                    generatedTitle = data.result?.trim() ?? '';
                                    if (generatedTitle) this._setTitleAI(generatedTitle);
                                    break;
                                case 'complete':
                                    generatedTitle = data.result?.trim() ?? '';
                                    if (generatedTitle) {
                                        this._setTitleAI(generatedTitle);
                                        trackAIResultView({
                                            doesNotMeetMAUCriteria: true,
                                            attributes: {
                                                contentType: contentType
                                            }
                                        });
                                        experienceTracker.succeed({
                                            name: (0, $irVI7.AI_TITLE_GENERATION)
                                        });
                                        setGeneratedTitle?.(generatedTitle);
                                    } else handleAiTitleError({
                                        errorMessage: 'Generated title is empty'
                                    });
                                    break;
                                case 'error':
                                    handleAiTitleError({
                                        errorMessage: data.errorInfo?.errorContent,
                                        errorCode: data.errorInfo?.statusCode
                                    });
                                    break;
                            }
                        }
                    }
                });
            }
        };
        this.generateDescription = ()=>{
            const { intl: { formatMessage: formatMessage }, contentType: contentType, isTemplateEditor: isTemplateEditor, isUnpublishedDraft: isUnpublishedDraft } = this.props;
            if (isUnpublishedDraft) {
                if (isTemplateEditor) return formatMessage($90aadbae3b7b5d0e$var$i18n.createPageTemplateTitleDescription);
                else return contentType === 'blogpost' ? formatMessage($90aadbae3b7b5d0e$var$i18n.createBlogpostTitleDescription) : formatMessage($90aadbae3b7b5d0e$var$i18n.createPageTitleDescription);
            } else return isTemplateEditor ? formatMessage($90aadbae3b7b5d0e$var$i18n.editPageTemplateTitleDescription) : formatMessage($90aadbae3b7b5d0e$var$i18n.editPageTitleDescription);
        };
        this._onTitleError = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, flagArray: flagArray, intl: intl, contentId: contentId, spaceId: spaceId, isAIEnabledForContent: isAIEnabledForContent } = this.props;
            const flagTitle = String(flagArray?.[0]?.title);
            const titleRequiredFlagTitle = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]: true
                },
                formatMessage: intl.formatMessage
            })?.title;
            const aiGeneratedTitleFlagTitle = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                },
                formatMessage: intl.formatMessage
            })?.title;
            if (flagArray && (flagTitle === titleRequiredFlagTitle || flagTitle === aiGeneratedTitleFlagTitle)) createAnalyticsEvent?.({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorTitle',
                    action: 'publishAttemptedEmptyTitle',
                    actionSubject: 'editor',
                    objectId: contentId,
                    objectType: 'page',
                    attributes: {
                        isLivePage: false,
                        isAiTitleEnabled: String(flagArray?.[0]?.title) === (0, $cHfGW.buildEditorFlagMessage)({
                            errorData: {
                                [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                            },
                            formatMessage: intl.formatMessage
                        })?.title
                    },
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            if (flagArray && String(flagArray?.[0]?.title) === (0, $cHfGW.buildEditorFlagMessage)({
                errorData: {
                    [(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]: true
                },
                formatMessage: intl.formatMessage
            })?.title && isAIEnabledForContent && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) {
                this._focusTextarea();
                this.generateTitle();
            } else {
                this._focusTextarea();
                this.setState({
                    shouldAnimateTitle: true
                });
                /*
         * Additional focus needed after animation bc setting the shouldAnimateTitle state will change the key of the textArea,
         * which means re-render will regenerate entire view, causing loss of focus
         */ setTimeout(()=>{
                    this.setState({
                        shouldAnimateTitle: false
                    });
                    this._focusTextarea();
                }, $90aadbae3b7b5d0e$var$ERROR_ANIMATION_DURATION);
            }
        };
        this._getTitlePlaceholder = ()=>{
            const { contentType: contentType, intl: intl, customPlaceholder: customPlaceholder } = this.props;
            if (customPlaceholder) return customPlaceholder;
            return contentType === 'blogpost' ? intl.formatMessage($90aadbae3b7b5d0e$var$i18n.blogpostTitlePlaceholder) : intl.formatMessage($90aadbae3b7b5d0e$var$i18n.editorOnboardingExpTitlePlaceholderText);
        };
        this._onFocus = ()=>{
            this._onFocusChanged(true);
        };
        this._onBlur = ()=>{
            this.props.onTitleBlur(this.state.title ?? undefined);
            this._onFocusChanged(false);
        };
        /**
     * Triggered from window resize event listener
     */ this._onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            this._updateHeightAuto();
        }, 200);
        this._onKeyDown = (event)=>{
            // If the user is composing characters using, e.g., the Hiragana - Kana keyboard,
            // short circuit the code to prevent the bug in Chrome where the selected text
            // gets copied into the editor body.
            if (event.nativeEvent.isComposing) return;
            // This is for an undo/redo shortcut for AI-generated titles
            if ((0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                const modifierKey = (0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey;
                const isUndoShortcut = event.key === 'z' && modifierKey && !event.shiftKey;
                const isRedoShortcut = event.key === 'z' && modifierKey && event.shiftKey;
                if (isUndoShortcut && this._undoRedoManager.canUndo()) {
                    event.preventDefault();
                    event.stopPropagation();
                    this._undoAIGeneratedTitle();
                    return;
                }
                if (isRedoShortcut && this._undoRedoManager.canRedo()) {
                    event.preventDefault();
                    event.stopPropagation();
                    this._redoAIGeneratedTitle();
                    return;
                }
            }
            // Shift+Tab should not be prevented, so we check if tab pressed without shift
            const isTabPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).TAB.key && !event.shiftKey;
            // If enter is pressed without publish keyboard shortcut prompt key, prevent default and insert newline in editor body
            const promptKeyForPublishShortcut = (0, $4tOXV.isMac)() ? event.metaKey : event.ctrlKey;
            const isEnterPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).ENTER.key && !promptKeyForPublishShortcut;
            const isDownArrowPressed = event.key === (0, $aK0Eq.KeyboardEventKeys).DOWN.key;
            if (isTabPressed || isEnterPressed || isDownArrowPressed) {
                event.preventDefault();
                event.stopPropagation();
                if (this.props.isTemplatesSuggestionsEnabled && this.props.templateButtonRef?.current) this.props.templateSuggestionsRef?.current?.focus();
                else {
                    const { editorApi: editorApi } = this.props;
                    if (isEnterPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.insertNewLineAtDocStart());
                    if (isTabPressed || isDownArrowPressed) editorApi?.core?.actions.execute(editorApi?.pageTitleUtils?.commands?.selectDocStart());
                    this.props.focusEditor();
                }
            }
        };
        this._textareaRef = /*#__PURE__*/ (0, $cozmU.createRef)();
        this._hasEditEventFiredRef = {
            current: false
        };
        this._undoRedoManager = new (0, $2SWmG.UndoRedoManager)();
    // Don't add initial title to undo stack - only add when title is about to change
    }
}
function $90aadbae3b7b5d0e$var$aiAnalyticsEvents(WrappedComponent) {
    const WithAIAnalyticsFn = function WithAIAnalytics(props) {
        const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView } = (0, $cFVPs.useAIEventsInstrumentation)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            trackAIInteractionInit: trackAIInteractionInit,
            trackAIResultError: trackAIResultError,
            trackAIResultView: trackAIResultView
        });
    };
    WithAIAnalyticsFn.displayName = 'WithAIAnalytics';
    return WithAIAnalyticsFn;
}
const $90aadbae3b7b5d0e$var$redactionsChangeboarding = (WrappedComponent)=>(props)=>{
        const { contentId: contentId, title: title } = props;
        (0, $2MwVI.useTrackTitleRedactionRendered)({
            contentId: contentId,
            title: title
        });
        const { activeSpotlight: activeSpotlight, renderMigratedSpotlight: renderMigratedSpotlight } = (0, $iuuqT.useRedactionsTour)({
            contentId: contentId,
            step: (0, $kycWk.RedactionsTourSteps).FIRST,
            firstStepSource: (0, $kycWk.RedactionTourStepSource).titleRedaction
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            activeRedactionsSpotlight: activeSpotlight,
            renderMigratedRedactionsSpotlight: renderMigratedSpotlight
        });
    };
$90aadbae3b7b5d0e$var$redactionsChangeboarding.displayName = 'RedactionsChangeboarding';
const $90aadbae3b7b5d0e$var$experienceTracking = (WrappedComponent)=>(props)=>{
        const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
$90aadbae3b7b5d0e$var$experienceTracking.displayName = 'ExperienceTracking';
const $90aadbae3b7b5d0e$export$813a56baf1599592 = //Adding HOC since flagArray is needed to trigger componentDidUpdate
(0, $7aRa9.withFlags)((0, $7mpOv.withIsAIEnabledForContent)((0, $kSwu1.injectIntl)($90aadbae3b7b5d0e$var$experienceTracking($90aadbae3b7b5d0e$var$redactionsChangeboarding($90aadbae3b7b5d0e$var$aiAnalyticsEvents((0, $lzgC6.default)()($90aadbae3b7b5d0e$var$EditorTitleComponentClass)))))));
$90aadbae3b7b5d0e$export$813a56baf1599592.displayName = 'EditorTitle';
module.exports["MAX_LENGTH_OF_TITLE"] = $90aadbae3b7b5d0e$export$f5770e9cb651fcf2;
module.exports["AI_SUGGEST_TITLE_PROPS"] = $90aadbae3b7b5d0e$export$aafacd47ca4852d;
module.exports["fieldSizingEnabled"] = $90aadbae3b7b5d0e$export$ca74a9f12ee60773;
module.exports["EditorTitle"] = $90aadbae3b7b5d0e$export$813a56baf1599592;

});

parcelRegister("8m9SI", function(module, exports) {
/* editorTitleStyled.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $fTmNK = parcelRequire("fTmNK");

const $d2d5c3ff61979fcc$var$shakeAnimation = null;
const $d2d5c3ff61979fcc$var$fadeUnderlineAnimation = null;
const $d2d5c3ff61979fcc$export$37076bfbe5bc34e4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAnimate: shouldAnimate, isTitleCenterAligned: isTitleCenterAligned, isDisabledTextBlack: isDisabledTextBlack, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgXwEm _30huDKYbGa _4bt5LAnQyn _2WAcuGnQyn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _1gBiby5irP _43vdfTN8t6 _0KLXruOLYo _1kk5Tku7m9 _0jFU0VIZbP _3iDTPbvLZJ _39HuIbz8Lp _2HIj7GYbGa _1ANEUSlpBW _24h04i2Njc _313842dnbC _39xV02N91d _2yQSRyy7kJ _0QAuWQjOvk _3tCyJvYbGa _2DoaPjYbGa _18HrT2YbGa _3AxjleKGUX _4w01rS7dHp _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.shouldAnimate ? "_0nFVCGipXj" : "_0nFVCGUaiG",
            __cmplp.isTitleCenterAligned ? "_2fwxA5DIqT" : "_2fwxA5yL8i",
            __cmplp.isDisabledTextBlack ? "_24bGaTy7kJ" : "_24bGaTot27",
            __cmplp.isTitleCenterAligned ? "_1S7apZDIqT" : "_1S7apZyL8i",
            __cmplp.className
        ])
    });
});
$d2d5c3ff61979fcc$export$37076bfbe5bc34e4.displayName = 'EditorTitleTextArea'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $d2d5c3ff61979fcc$export$4b3be882d63e1514 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $d2d5c3ff61979fcc$export$37076bfbe5bc34e4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iHkq9a6YE",
            __cmplp.className
        ])
    });
});
$d2d5c3ff61979fcc$export$4b3be882d63e1514.displayName = 'EditorTitleTextAreaNext';
const $d2d5c3ff61979fcc$var$aiGeneratedStyle = null;
const $d2d5c3ff61979fcc$export$7efa51f4cf8cfb64 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ isTitleAIGenerated: isTitleAIGenerated = false, ...props }, ref)=>{
    if ((0, $fTmNK.fieldSizingEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d5c3ff61979fcc$export$4b3be882d63e1514, {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            isTitleAIGenerated && "",
            isTitleAIGenerated && "_1gBibydRkY _0nFVCG2UbV _0uDzWjzSxU"
        ])
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2d5c3ff61979fcc$export$37076bfbe5bc34e4, {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            isTitleAIGenerated && "",
            isTitleAIGenerated && "_1gBibydRkY _0nFVCG2UbV _0uDzWjzSxU"
        ])
    });
});
$d2d5c3ff61979fcc$export$7efa51f4cf8cfb64.displayName = 'AIGeneratedEditorTitleTextArea';
module.exports["EditorTitleTextArea"] = $d2d5c3ff61979fcc$export$37076bfbe5bc34e4;
module.exports["EditorTitleTextAreaNext"] = $d2d5c3ff61979fcc$export$4b3be882d63e1514;
module.exports["AIGeneratedEditorTitleTextArea"] = $d2d5c3ff61979fcc$export$7efa51f4cf8cfb64;

});

parcelRegister("i0AJ7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $584dfcc5531b805f$var$containerBaseStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    flexDirection: 'column',
    gap: 'space.075',
    width: '100%',
    marginBottom: 'initial',
    marginTop: 'space.025'
});
const $584dfcc5531b805f$export$9a8b9ed43da05bcf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        testId: "editor-title-container",
        "data-test-id": "editor-title-container",
        id: "editor-title-id",
        xcss: [
            $584dfcc5531b805f$var$containerBaseStyles
        ]
    }, children);
$584dfcc5531b805f$export$9a8b9ed43da05bcf.displayName = 'EditorTitleContainer';
module.exports["EditorTitleContainer"] = $584dfcc5531b805f$export$9a8b9ed43da05bcf;

});

parcelRegister("idaAv", function(module, exports) {
/**
 * Checks if the browser supports the field-sizing CSS property
 */ const $91f723cc1d918a38$export$a533e379d25c784e = ()=>{
    return CSS.supports('field-sizing', 'content');
};
module.exports["isFieldSizingSupported"] = $91f723cc1d918a38$export$a533e379d25c784e;

});

parcelRegister("fazoG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $cFVPs = parcelRequire("cFVPs");


var $9XB2W = parcelRequire("9XB2W");


var $hycHC = parcelRequire("hycHC");


var $kdpMy = parcelRequire("kdpMy");





var $6mKj3 = parcelRequire("6mKj3");


var $7mpOv = parcelRequire("7mpOv");

const $4c5cb41c7031031e$export$9e96e64db7f7aab0 = (contentId, userOffline, isEditorEmpty, isLivePage, titleTextAreaRef)=>{
    const PASTE_CONTEXT_EXTRACTION_DELAY = 100; // Wait for paste to be applied to DOM
    const PASTE_RESET_DELAY = 500; // Used to reset paste detection
    const MIN_PASTED_CHAR_LENGTH = 50;
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const [pasteDetected, setPasteDetected] = (0, $cozmU.useState)(false);
    const isEditorEmptyRef = (0, $cozmU.useRef)(isEditorEmpty);
    (0, $cozmU.useEffect)(()=>{
        isEditorEmptyRef.current = isEditorEmpty;
    }, [
        isEditorEmpty
    ]);
    const isFeatureEnabled = isAIEnabledForContent && !userOffline;
    const findProseMirrorElement = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const filteredProseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]'));
        return filteredProseMirrors[0];
    }, []);
    const resetPasteDetected = (0, $cozmU.useCallback)(()=>{
        setPasteDetected(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isFeatureEnabled) return;
        const proseMirrorElement = findProseMirrorElement();
        if (!proseMirrorElement) return;
        let postPasteReadTimeoutId;
        const handlePaste = (event)=>{
            const pastedText = event.clipboardData?.getData('text/plain') || '';
            const currentTitle = titleTextAreaRef?.current?.value ?? '';
            const wasEditorEmpty = isEditorEmptyRef.current;
            if (currentTitle.trim() !== '') return;
            if (wasEditorEmpty && pastedText.length > MIN_PASTED_CHAR_LENGTH) {
                if (postPasteReadTimeoutId !== undefined) clearTimeout(postPasteReadTimeoutId);
                postPasteReadTimeoutId = setTimeout(()=>{
                    postPasteReadTimeoutId = undefined;
                    const extractedContext = proseMirrorElement.textContent || '';
                    if (extractedContext.trim().length > 0) {
                        if (!isLivePage || isLivePage && (0, $6mKj3.expValEquals)('confluence_ai_title_generation_on_paste', 'isEnabled', true)) setPasteDetected(true);
                    }
                }, PASTE_CONTEXT_EXTRACTION_DELAY);
            }
        };
        proseMirrorElement.addEventListener('paste', handlePaste);
        return ()=>{
            if (postPasteReadTimeoutId !== undefined) clearTimeout(postPasteReadTimeoutId);
            proseMirrorElement.removeEventListener('paste', handlePaste);
        };
    }, [
        findProseMirrorElement,
        isFeatureEnabled,
        isLivePage,
        titleTextAreaRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (pasteDetected) {
            const timer = setTimeout(()=>setPasteDetected(false), PASTE_RESET_DELAY);
            return ()=>clearTimeout(timer);
        }
    }, [
        pasteDetected
    ]);
    return {
        pasteDetected: pasteDetected,
        resetPasteDetected: resetPasteDetected
    };
};


const $c718dbc8e48ba983$export$ae17174c27bb849d = 500;
const $c718dbc8e48ba983$export$7bf2ce6691f6cc36 = 1800000; // 30 minutes
const $c718dbc8e48ba983$export$dc822afbc4cf68ee = 50; // % word change before firing "deleted" event
// Word-based Levenshtein distance
const $c718dbc8e48ba983$var$wordLevenshteinDistance = (str1, str2)=>{
    const words1 = str1.trim().split(/\s+/).filter(Boolean);
    const words2 = str2.trim().split(/\s+/).filter(Boolean);
    const m = words1.length;
    const n = words2.length;
    const dp = Array.from({
        length: m + 1
    }, ()=>Array(n + 1).fill(0));
    for(let i = 0; i <= m; i++)dp[i][0] = i;
    for(let j = 0; j <= n; j++)dp[0][j] = j;
    for(let i = 1; i <= m; i++){
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        for(let j = 1; j <= n; j++)if (words1[i - 1].toLowerCase() === words2[j - 1].toLowerCase()) dp[i][j] = dp[i - 1][j - 1];
        else dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
    return dp[m][n];
};
const $c718dbc8e48ba983$export$1fc9f1e5fda37acb = (aiGeneratedTitle, currentTitle)=>{
    const aiWords = aiGeneratedTitle.trim().split(/\s+/).filter(Boolean);
    const currentWords = currentTitle.trim().split(/\s+/).filter(Boolean);
    const maxWordCount = Math.max(aiWords.length, currentWords.length);
    if (maxWordCount === 0) return 100; // Both titles empty = 100% changed
    const distance = $c718dbc8e48ba983$var$wordLevenshteinDistance(aiGeneratedTitle, currentTitle);
    return distance / maxWordCount * 100;
};
const $c718dbc8e48ba983$var$getTargetEditorId = (textAreaRef)=>{
    const editors = Array.from(textAreaRef.current?.closest('.ak-editor-content-area')?.querySelectorAll('.ProseMirror') ?? []).filter((editor)=>!editor.closest('[data-editor-popup]'));
    return editors[0]?.dataset.editorId;
};
const $c718dbc8e48ba983$export$76f5ace58b4f15c8 = ({ textAreaRef: textAreaRef, isEditorEmpty: isEditorEmpty, userOffline: userOffline, contentId: contentId, contentType: contentType, isLivePage: isLivePage, title: title, flags: flags, i18n: i18n, formatMessage: formatMessage, onTitleGenerated: onTitleGenerated, onTitleGeneratingChange: onTitleGeneratingChange })=>{
    const [isGenerating, setIsGenerating] = (0, $cozmU.useState)(false);
    const generationTimeoutRef = (0, $cozmU.useRef)(null);
    const aiResultViewTimeoutRef = (0, $cozmU.useRef)(null);
    const wasGeneratingRef = (0, $cozmU.useRef)(false);
    const originalGeneratedTitleRef = (0, $cozmU.useRef)(null);
    const generatedOnContentIdRef = (0, $cozmU.useRef)(null);
    const currentTitleRef = (0, $cozmU.useRef)(title);
    const latestStreamedTitleRef = (0, $cozmU.useRef)('');
    const fireResultAnalyticsRef = (0, $cozmU.useRef)(()=>{});
    const previousContentIdRef = (0, $cozmU.useRef)(contentId);
    currentTitleRef.current = title;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $cFVPs.useAIEventsInstrumentation)();
    const generatedTitleActions = (0, $kdpMy.useGeneratedTitleActions)();
    const { pasteDetected: pasteDetected, resetPasteDetected: resetPasteDetected } = (0, $4c5cb41c7031031e$export$9e96e64db7f7aab0)(contentId, userOffline ?? false, isEditorEmpty ?? false, isLivePage, textAreaRef);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (generationTimeoutRef.current) clearTimeout(generationTimeoutRef.current);
            if (aiResultViewTimeoutRef.current) clearTimeout(aiResultViewTimeoutRef.current);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!pasteDetected) return;
        const targetEditorId = $c718dbc8e48ba983$var$getTargetEditorId(textAreaRef);
        if (targetEditorId) {
            trackAIInteractionInit({
                attributes: {
                    aiFeatureName: 'aiTitleGenOnPaste',
                    doesNotMeetMAUCriteria: true,
                    isLivePage: isLivePage,
                    contentType: contentType
                }
            });
            (0, $9XB2W.eventHub).publishToEditor({
                event: 'start prompt',
                data: {
                    targetEditorId: targetEditorId,
                    adjustSelection: 'fullDocument',
                    analyticSourceId: 'confluenceTitleGenOnPaste',
                    prompt: 'suggest title'
                }
            });
        }
        resetPasteDetected();
    }, [
        resetPasteDetected,
        pasteDetected,
        textAreaRef,
        trackAIInteractionInit,
        isLivePage,
        contentType
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (flags && isGenerating) {
            flags.hideFlag('ai-generated-title-from-paste-flag');
            flags.showInfoFlag({
                id: 'ai-generated-title-from-paste-flag',
                title: formatMessage(i18n.aiGeneratedTitleFromPaste),
                description: formatMessage(i18n.aiGeneratedTitleFromPasteDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence"
                        }, chunks)
                }),
                actions: [
                    {
                        content: formatMessage(i18n.aiGeneratedTitleDismissButton),
                        onClick: ()=>flags.hideFlag('ai-generated-title-from-paste-flag')
                    }
                ]
            });
        }
    }, [
        isGenerating,
        formatMessage,
        flags,
        i18n
    ]);
    const fireResultAnalytics = (0, $cozmU.useCallback)(()=>{
        const originalTitle = originalGeneratedTitleRef.current;
        const generatedOnContentId = generatedOnContentIdRef.current;
        if (originalTitle === null || generatedOnContentId === null) return;
        const currentTitle = currentTitleRef.current ?? '';
        if (originalTitle.trim().length > 0) {
            const changePercentage = $c718dbc8e48ba983$export$1fc9f1e5fda37acb(originalTitle, currentTitle);
            if (changePercentage < $c718dbc8e48ba983$export$dc822afbc4cf68ee) {
                trackAIResultView({
                    attributes: {
                        aiFeatureName: 'aiTitleGenOnPaste',
                        doesNotMeetMAUCriteria: true,
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                });
                trackAIResultAction('aiTitleGenOnPaste', {
                    attributes: {
                        aiFeatureName: 'aiTitleGenOnPaste',
                        doesNotMeetMAUCriteria: true,
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                });
            } else createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'aiTitleGenOnPaste',
                    source: 'confluencePage',
                    attributes: {
                        contentId: generatedOnContentId,
                        isLivePage: isLivePage,
                        contentType: contentType
                    }
                }
            }).fire();
        }
        originalGeneratedTitleRef.current = null;
        generatedOnContentIdRef.current = null;
        if (aiResultViewTimeoutRef.current) {
            clearTimeout(aiResultViewTimeoutRef.current);
            aiResultViewTimeoutRef.current = null;
        }
        // Clear stored callback so publish doesn't fire analytics again (standard pages only)
        if (!isLivePage) generatedTitleActions.clearGeneratedTitleFromPaste();
    }, [
        isLivePage,
        contentType,
        createAnalyticsEvent,
        trackAIResultView,
        trackAIResultAction,
        generatedTitleActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (wasGeneratingRef.current && !isGenerating) {
            const generatedTitle = latestStreamedTitleRef.current ?? '';
            originalGeneratedTitleRef.current = generatedTitle;
            generatedOnContentIdRef.current = contentId;
            if (generatedTitle && onTitleGenerated) onTitleGenerated(generatedTitle);
            if (aiResultViewTimeoutRef.current) clearTimeout(aiResultViewTimeoutRef.current);
            aiResultViewTimeoutRef.current = setTimeout(()=>{
                fireResultAnalytics();
            }, $c718dbc8e48ba983$export$7bf2ce6691f6cc36);
            // Standard pages: also store callback for publish trigger
            if (!isLivePage) {
                generatedTitleActions.setGeneratedTitleFromPaste(generatedTitle);
                generatedTitleActions.setFireResultAnalyticsFromPaste(fireResultAnalytics);
            }
        }
        wasGeneratingRef.current = isGenerating;
        onTitleGeneratingChange?.(isGenerating);
    }, [
        isGenerating,
        fireResultAnalytics,
        contentId,
        onTitleGenerated,
        onTitleGeneratingChange,
        isLivePage,
        generatedTitleActions
    ]);
    fireResultAnalyticsRef.current = fireResultAnalytics;
    // Fire analytics when contentId changes (page navigation where component doesn't unmount)
    // This handles scenarios like live page -> live page navigation
    (0, $cozmU.useEffect)(()=>{
        if (previousContentIdRef.current !== contentId) {
            fireResultAnalyticsRef.current();
            previousContentIdRef.current = contentId;
        }
    }, [
        contentId
    ]);
    // Fire analytics on page leave/unmount
    (0, $cozmU.useEffect)(()=>{
        const handleBeforeUnload = ()=>{
            fireResultAnalyticsRef.current();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
            fireResultAnalyticsRef.current();
        };
    }, []);
    // Track streaming chunks to detect when generation completes
    const handleTitleChunk = (0, $cozmU.useCallback)((newTitle)=>{
        latestStreamedTitleRef.current = newTitle;
        if (generationTimeoutRef.current) clearTimeout(generationTimeoutRef.current);
        setIsGenerating(true);
        generationTimeoutRef.current = setTimeout(()=>{
            setIsGenerating(false);
            generationTimeoutRef.current = null;
        }, $c718dbc8e48ba983$export$ae17174c27bb849d);
    }, []);
    (0, $hycHC.useEditorAIReplacingTitle)({
        enabled: true,
        title: title || '',
        handleNewTitle: handleTitleChunk,
        canFireUnifiedAIAnalyticsEvent: false
    });
};


const $6426cb64e10fea12$export$efe6e7371877ae2 = ({ contentId: contentId, contentType: contentType, textAreaRef: textAreaRef, title: title, isLivePage: isLivePage, isEditorEmpty: isEditorEmpty, userOffline: userOffline, flags: flags, i18n: i18n, formatMessage: formatMessage, onTitleGenerated: onTitleGenerated, onTitleGeneratingChange: onTitleGeneratingChange })=>{
    (0, $c718dbc8e48ba983$export$76f5ace58b4f15c8)({
        contentId: contentId,
        contentType: contentType,
        textAreaRef: textAreaRef,
        title: title,
        isLivePage: isLivePage,
        isEditorEmpty: isEditorEmpty,
        userOffline: userOffline,
        flags: flags,
        i18n: i18n,
        formatMessage: formatMessage,
        onTitleGenerated: onTitleGenerated,
        onTitleGeneratingChange: onTitleGeneratingChange
    });
    return null;
};
module.exports["TitleGenerationOnPaste"] = $6426cb64e10fea12$export$efe6e7371877ae2;

});

parcelRegister("2SWmG", function(module, exports) {
const $65022a69dfe103a5$var$DEFAULT_MAX_STACK_SIZE = 50;
class $65022a69dfe103a5$export$2aef42d075d45ec5 {
    trimStack(stack) {
        while(stack.length > this.maxStackSize)stack.shift();
    }
    addToUndoStack(title) {
        // Don't add duplicate consecutive states (compare by title)
        const lastState = this.undoStack[this.undoStack.length - 1];
        if (!lastState || lastState !== title) {
            this.undoStack.push(title);
            this.trimStack(this.undoStack);
        }
    }
    undo(currentTitle) {
        if (this.undoStack.length === 0) return currentTitle;
        // Peek at the top of the stack - if it's the same title as current state, skip it
        while(this.undoStack.length > 0 && this.undoStack[this.undoStack.length - 1] === currentTitle)this.undoStack.pop();
        if (this.undoStack.length === 0) return currentTitle;
        const previousState = this.undoStack.pop();
        // Only add to redo stack if the titles are different
        if (previousState !== currentTitle) {
            this.redoStack.push(currentTitle);
            this.trimStack(this.redoStack);
        }
        return previousState;
    }
    redo(currentTitle) {
        if (this.redoStack.length > 0) {
            const nextState = this.redoStack.pop();
            // Only add to undo stack if the titles are different
            if (nextState !== currentTitle) {
                this.undoStack.push(currentTitle);
                this.trimStack(this.undoStack);
            }
            return nextState;
        }
        return currentTitle;
    }
    canUndo() {
        return this.undoStack.length > 0;
    }
    canRedo() {
        return this.redoStack.length > 0;
    }
    clear() {
        this.undoStack = [];
        this.redoStack = [];
    }
    constructor(maxStackSize = $65022a69dfe103a5$var$DEFAULT_MAX_STACK_SIZE){
        this.undoStack = [];
        this.redoStack = [];
        this.maxStackSize = void 0;
        this.maxStackSize = maxStackSize;
    }
}
module.exports["UndoRedoManager"] = $65022a69dfe103a5$export$2aef42d075d45ec5;

});

parcelRegister("5epXp", function(module, exports) {
/**
 * @generated SignedSource<<b2a70c204c9e9b54d164356b51ec9118>>
 * @relayHash 35f5e3f66dc313d164a4583c9807f5ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b615f753b0480e46bae977b401d820c278a5e71e7a60723f1d836a2f3155542d
const $dc42ee61ad89f7ea$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeStudioAutomationDiscovery"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorTitleWithTitleAreaComponentsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeStudioAutomationDiscovery",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "MeetingNotesAutomationDiscoveryFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "meetingNotesAutomationDiscovery"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorTitleWithTitleAreaComponentsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "condition": "includeStudioAutomationDiscovery",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sourceTemplateEntityId"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "35f5e3f66dc313d164a4583c9807f5ab",
            "id": "b615f753b0480e46bae977b401d820c278a5e71e7a60723f1d836a2f3155542d",
            "metadata": {},
            "name": "EditorTitleWithTitleAreaComponentsQuery",
            "operationKind": "query",
            "text": "query EditorTitleWithTitleAreaComponentsQuery($contentId:ID!,$cloudId:ID!,$includeStudioAutomationDiscovery:Boolean!){singleContent(cloudId:$cloudId,id:$contentId){...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeStudioAutomationDiscovery),id}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}"
        }
    };
}();
$dc42ee61ad89f7ea$var$node.hash = "6b1015f0c0056c5a4f41226ec77c1791";
var $dc42ee61ad89f7ea$export$2e2bcd8739ae039 = $dc42ee61ad89f7ea$var$node;



var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $iODl6 = parcelRequire("iODl6");


var $i7cz5 = parcelRequire("i7cz5");


var $lC6Qd = parcelRequire("lC6Qd");


var $bKd7w = parcelRequire("bKd7w");


var $3WPGR = parcelRequire("3WPGR");


var $laFNM = parcelRequire("laFNM");


var $b3j2Y = parcelRequire("b3j2Y");


var $ktUCG = parcelRequire("ktUCG");


var $bJX6u = parcelRequire("bJX6u");


var $cxu5H = parcelRequire("cxu5H");


var $5vi32 = parcelRequire("5vi32");


var $gqqjz = parcelRequire("gqqjz");


var $2HGN8 = parcelRequire("2HGN8");


var $5DJsZ = parcelRequire("5DJsZ");


var $7PLO8 = parcelRequire("7PLO8");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $LSims = parcelRequire("LSims");


var $3jwuS = parcelRequire("3jwuS");


var $jmjWc = parcelRequire("jmjWc");


const $8154f88738818571$export$f935dade49f9740 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WX_AK",
    name: "CopyWithRovoLoadable",
    loader: async ()=>(await (parcelRequire("d4IMD"))).CopyWithRovo,
    loading: ()=>null
});



var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bMPhU = parcelRequire("bMPhU");


var $jLw6A = parcelRequire("jLw6A");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");








const $1c4544a2fa66a7a2$export$e8e7631381a283f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "AY3Dw",
    name: "SuggestWhiteboardOnPageTitle",
    loader: async ()=>(await (parcelRequire("bYkJQ"))).SuggestWhiteboardOnPageTitleErrorBoundary
});






const $6981bbd475ce8ca7$export$20f99fd00736b20 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "M_cPB",
    name: "LazyEditorTitleAreaBanner",
    loader: async ()=>(await (parcelRequire("fLt7u"))).EditorTitleAreaBannerErrorBoundary
});






const $bba9d309d79f14df$export$324976fee0b64395 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "3nYRE",
    name: "LazyAgentTitleAreaBanner",
    loader: async ()=>(await (parcelRequire("fpvDE"))).AgentTitleAreaBannerErrorBoundary
});






const $06994e2bc47ea9f1$export$b80ef436249adad3 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "lR7ho",
    name: "LazyMeetingSignalTitleNudge",
    loader: async ()=>(await (parcelRequire("dwWZ5"))).MeetingSignalTitleNudge
});



var $kygIi = parcelRequire("kygIi");

/* TitleSection.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $8z0fF = parcelRequire("8z0fF");





var $75Ax4 = parcelRequire("75Ax4");


var $jVylI = parcelRequire("jVylI");

const $d765f449481d5188$var$mainBoxStylesBase = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
});
const $d765f449481d5188$var$mainBoxStylesGapSpace0 = (0, $buxP3.xcss)({
    gap: 'space.0'
});
const $d765f449481d5188$var$mainBoxStylesGapSpace300 = (0, $buxP3.xcss)({
    gap: 'space.300'
});
const $d765f449481d5188$var$titleBoxStylesBase = (0, $buxP3.xcss)({
    position: 'relative',
    width: '100%'
});
const $d765f449481d5188$var$titleBoxStylesDisplayFlex = (0, $buxP3.xcss)({
    display: 'flex'
});
const $d765f449481d5188$var$titleBoxStylesFlexDirectionColumn = (0, $buxP3.xcss)({
    flexDirection: 'column'
});
const $d765f449481d5188$var$titleBoxStylesFlexDirectionInitial = (0, $buxP3.xcss)({
    flexDirection: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesGapSpace300 = (0, $buxP3.xcss)({
    gap: 'space.300'
});
const $d765f449481d5188$var$titleBoxStylesMarginTopMinus90px = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px'
});
const $d765f449481d5188$var$titleBoxStylesMarginTopInitial = (0, $buxP3.xcss)({
    marginTop: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesMarginBottomInitial = (0, $buxP3.xcss)({
    marginBottom: 'initial'
});
const $d765f449481d5188$var$titleBoxStylesAlignItemsCenter = (0, $buxP3.xcss)({
    alignItems: 'center'
});
const $d765f449481d5188$var$titleBoxStylesAlignItemsInitial = (0, $buxP3.xcss)({
    alignItems: 'initial'
});
const $d765f449481d5188$var$contentTopperBoxStylesBase = (0, $buxP3.xcss)({
    alignSelf: 'normal'
});
const $d765f449481d5188$var$contentTopperBoxStylesMarginTopSpaceNegative300 = (0, $buxP3.xcss)({
    marginTop: 'space.negative.300'
});
const $d765f449481d5188$var$emojiHiddenStyles = (0, $buxP3.xcss)({
    visibility: 'hidden'
});
const $d765f449481d5188$var$emojiHeightStyles = (0, $buxP3.xcss)({
    height: '88px'
});
const $d765f449481d5188$var$marginTopSpace0Styles = (0, $buxP3.xcss)({
    marginTop: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d765f449481d5188$var$EmojiTitleSelectionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_3iDTPbQ4SZ" : "_3iDTPbyL8i",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.isTitleCenterAligned ? "_0hPCNLDIqT" : "_0hPCNLzUZr",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
            __cmplp.hasCoverPicture ? "_39xV02E6Kk" : "_39xV02IZbP",
            __cmplp.hasCoverPicture && (__cmplp.hasEmoji || __cmplp.isSpaceOverview) ? "_313842dBVr" : "_313842dnbC",
            __cmplp.className
        ])
    });
});
$d765f449481d5188$var$EmojiTitleSelectionWrapper.displayName = 'EmojiTitleSelectionWrapper';
const $d765f449481d5188$var$baseEditorTitleStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $d765f449481d5188$var$fixedWidthLeftAlignImageStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $75Ax4.COVER_IMAGE_FIXED_WIDTH)}px`,
    margin: '0 auto',
    paddingLeft: 'space.250'
});
const $d765f449481d5188$export$718e92491c44b3f6 = ({ contentId: contentId, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, editorTitle: editorTitle, isTemplateEditor: isTemplateEditor, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isRemovingEmoji: isRemovingEmoji, contentTopperComponent: contentTopperComponent, isReadOnly: isReadOnly, coverPictureWidth: coverPictureWidth, isPageContentFullWidth: isPageContentFullWidth, isTitleAlignmentLoading: isTitleAlignmentLoading, isSpaceOverview: isSpaceOverview, pageTitleContent: pageTitleContent, isAutoPageEmojiEligible: isAutoPageEmojiEligible, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, emojiTitleDiscovered: emojiTitleDiscovered, contentType: contentType, isSmartCreate: isSmartCreate })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldBylineRenderContentTopper = isLivePage || !isSpaceOverview;
    const isContentTopperLayout = isTitleCenterAligned || hasCoverPicture;
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const marginTopStyleForTitleWithCoverPicture = hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesMarginTopMinus90px : $d765f449481d5188$var$titleBoxStylesMarginTopInitial;
    const titleXcss = [
        $d765f449481d5188$var$titleBoxStylesBase,
        // display
        $d765f449481d5188$var$titleBoxStylesDisplayFlex,
        // flexDirection
        isTitleCenterAligned || hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesFlexDirectionColumn : $d765f449481d5188$var$titleBoxStylesFlexDirectionInitial,
        // gap
        isTitleCenterAligned && hasEmoji && !hasCoverPicture ? $d765f449481d5188$var$titleBoxStylesGapSpace300 : undefined,
        // marginBottom
        $d765f449481d5188$var$titleBoxStylesMarginBottomInitial,
        // alignItems
        hasCoverPicture && isTitleCenterAligned ? $d765f449481d5188$var$titleBoxStylesAlignItemsCenter : $d765f449481d5188$var$titleBoxStylesAlignItemsInitial,
        // marginTop
        marginTopStyleForTitleWithCoverPicture
    ];
    const titleSectionStyles = [
        $d765f449481d5188$var$mainBoxStylesBase,
        !hasCoverPicture ? $d765f449481d5188$var$mainBoxStylesGapSpace0 : $d765f449481d5188$var$mainBoxStylesGapSpace300
    ];
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: titleSectionStyles
    }, !isContentTopperLayout && !shouldBylineRenderContentTopper && contentTopperComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    ), {
        xcss: titleXcss,
        testId: isTitleCenterAligned ? 'title-wrapper-centered' : 'title-wrapper'
    }, !isTemplateEditor && (!isRemovingEmoji || hasCoverPicture) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            hasCoverPicture && $d765f449481d5188$var$emojiHeightStyles,
            isRemovingEmoji && hasCoverPicture && $d765f449481d5188$var$emojiHiddenStyles,
            $d765f449481d5188$var$marginTopSpace0Styles,
            hasCoverPicture && isFixedWidth && isPageContentFullWidth && !isTitleCenterAligned && $d765f449481d5188$var$fixedWidthLeftAlignImageStyles
        ]
    }, isTitleAlignmentLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d765f449481d5188$var$EmojiTitleSelectionWrapper, {
        "data-testid": isTitleCenterAligned ? 'emoji-title-selection-wrapper-centered' : 'emoji-title-selection-wrapper',
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        isSpaceOverview: isSpaceOverview
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z0fF.EmojiTitleSelection), {
        contentId: contentId,
        onUpdateStartEmoji: onUpdateStartEmoji,
        onUpdateEndEmoji: onUpdateEndEmoji,
        isTitleDisabled: isTitleDisabled,
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: !!hasCoverPicture,
        linkCreation: linkCreation,
        isReadOnly: isReadOnly,
        hasInitialEmoji: hasEmoji,
        pageTitleContent: pageTitleContent,
        isAutoPageEmojiEligible: isAutoPageEmojiEligible,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        emojiTitleDiscovered: emojiTitleDiscovered,
        contentType: contentType,
        isSmartCreate: isSmartCreate
    }))), isContentTopperLayout && !shouldBylineRenderContentTopper && contentTopperComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $d765f449481d5188$var$contentTopperBoxStylesBase,
            (hasCoverPicture || hasEmoji && !isRemovingEmoji) && !isSpaceOverview && $d765f449481d5188$var$contentTopperBoxStylesMarginTopSpaceNegative300
        ]
    }, contentTopperComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $d765f449481d5188$var$baseEditorTitleStyles
        ]
    }, editorTitle))));
};
$d765f449481d5188$export$718e92491c44b3f6.displayName = 'TitleSection';


/* ToolbarAboveTitle.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $9DHhW = parcelRequire("9DHhW");








var $e4o8D = parcelRequire("e4o8D");


var $5RPbY = parcelRequire("5RPbY");





var $eToX6 = parcelRequire("eToX6");


var $i9VoI = parcelRequire("i9VoI");





var $5ZqQS = parcelRequire("5ZqQS");











var $3IBnw = parcelRequire("3IBnw");








var $7mpOv = parcelRequire("7mpOv");


var $bUiJC = parcelRequire("bUiJC");


var $jPcvk = parcelRequire("jPcvk");





var $lfoFx = parcelRequire("lfoFx");







/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 





const $af1520b6957343e5$var$rainbowGradientKeyframes = null;
const $af1520b6957343e5$var$rainbowGradient = null;
const $af1520b6957343e5$var$container = null;
const $af1520b6957343e5$export$388cb1c811714c72 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "animated-loading-gradient",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VN91d _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fd6mz _2fBhteRdpu _0jFU0VN91d _39xV02N91d _3OqcjTQ11f _1llTr6ZRaS"
        ])
    }));
};






var $jPACe = parcelRequire("jPACe");

const $42b1c9f0169a6e1e$var$coverPictureAndButtonWithCoverPictureAreaBoxStyles = (0, $buxP3.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});
const $42b1c9f0169a6e1e$var$coverPictureAndButtonWithoutCoverPictureAreaBoxStyles = (0, $buxP3.xcss)({
    width: 'unset',
    marginBottom: 'unset'
});
const $42b1c9f0169a6e1e$var$coverPictureAndButtonWithFloatingToolbarBoxStyles = (0, $buxP3.xcss)({
    marginRight: 'space.0',
    display: 'flex',
    justifyContent: 'center'
});
const $42b1c9f0169a6e1e$var$coverPictureAndButtonWithFloatingToolbarAndUploadingBoxStyles = (0, $buxP3.xcss)({
    opacity: 0
});
const $42b1c9f0169a6e1e$var$coverPictureAndButtonWithoutFloatingToolbarAndUploadingBoxStyles = (0, $buxP3.xcss)({
    opacity: 1
});
const $42b1c9f0169a6e1e$var$uploadingPictureBoxStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    position: 'relative'
});
const $42b1c9f0169a6e1e$export$bd378463497634f0 = ({ contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, updateHeight: updateHeight, currentHeight: currentHeight, isReadOnly: isReadOnly, isDraftLockedForEditing: isDraftLockedForEditing, spaceKey: spaceKey, isUnsplash: isUnsplash, dynamicCoverImageHeight: dynamicCoverImageHeight, width: width, coverImageWidth: coverImageWidth, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isSmartCreate: isSmartCreate })=>{
    const heightChangeThreshold = 4;
    (0, $cozmU.useEffect)(()=>{
        if (updateHeight && currentHeight && dynamicCoverImageHeight && Math.abs(currentHeight - dynamicCoverImageHeight) > heightChangeThreshold) updateHeight(dynamicCoverImageHeight);
    }, [
        updateHeight,
        currentHeight,
        dynamicCoverImageHeight
    ]);
    const coverPictureAndButtonXcss = [];
    if (isUploadingPicture || hasCoverPicture) coverPictureAndButtonXcss.push($42b1c9f0169a6e1e$var$coverPictureAndButtonWithCoverPictureAreaBoxStyles);
    else coverPictureAndButtonXcss.push($42b1c9f0169a6e1e$var$coverPictureAndButtonWithoutCoverPictureAreaBoxStyles);
    coverPictureAndButtonXcss.push($42b1c9f0169a6e1e$var$coverPictureAndButtonWithFloatingToolbarBoxStyles);
    if (isUploadingPicture) coverPictureAndButtonXcss.push($42b1c9f0169a6e1e$var$coverPictureAndButtonWithFloatingToolbarAndUploadingBoxStyles);
    else coverPictureAndButtonXcss.push($42b1c9f0169a6e1e$var$coverPictureAndButtonWithoutFloatingToolbarAndUploadingBoxStyles);
    const isGeneratingHeaderImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const uploadingPictureInlineCss = {
        width: width && !isFixedWidthImageOption ? `${width}px` : '100%',
        height: `${dynamicCoverImageHeight}px`,
        position: isFixedWidthImageOption ? 'relative' : 'absolute',
        // This is a dynamic value so tokens cannot be used here
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '0px'
    };
    const LoadingIndicator = ()=>{
        // isGeneratingHeaderImage will always be false when the experiment is off,
        // but evaluating here anyway for additional safety
        if (isGeneratingHeaderImage && ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') || (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af1520b6957343e5$export$388cb1c811714c72), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            testId: "CoverPictureAndButton-Spinner"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isUploadingPicture && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $42b1c9f0169a6e1e$var$uploadingPictureBoxStyles,
        testId: "uploading-picture-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: uploadingPictureInlineCss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LoadingIndicator, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: coverPictureAndButtonXcss,
        testId: "cover-picture-and-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPACe.EditorPageCoverPictureEntry), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        isFixedWidthImageOption: isFixedWidthImageOption,
        width: coverImageWidth,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly || !!isDraftLockedForEditing,
        spaceKey: spaceKey,
        hasCoverPicture: hasCoverPicture,
        isUnsplash: isUnsplash,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        aiHeaderImageError: aiHeaderImageError,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus,
        isSmartCreate: isSmartCreate
    })));
};









var $iMnC5 = parcelRequire("iMnC5");


var $5e34M = parcelRequire("5e34M");

const $8cc701d489c817ee$export$e6ce3311a4d41b7f = ({ contentId: contentId, userOffline: userOffline, isDraftLockedForEditing: isDraftLockedForEditing, isTitleDisabled: isTitleDisabled, isUnpublishedDraft: isUnpublishedDraft, setSelectedEmoji: setSelectedEmoji, onEmojiPickerLoaded: onEmojiPickerLoaded, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentType: contentType, isAutoPageEmojiEligible: isAutoPageEmojiEligible, emojiTitleDiscovered: emojiTitleDiscovered, isSmartCreate: isSmartCreate })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleOnMouseEnter = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                source: 'EmojiTitleSection',
                actionSubject: 'pageTitle',
                actionSubjectId: 'emojiButton',
                attributes: {
                    element: 'div'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMouseLeave = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'not:hovered',
                source: 'EmojiTitleSection',
                actionSubject: 'pageTitle',
                actionSubjectId: 'emojiButton',
                attributes: {
                    element: 'div'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "emoji-title-hover-button-wrapper",
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e34M.EmojiTitleButtonLoader), {
        isUnpublishedDraft: isUnpublishedDraft,
        setSelectedEmoji: setSelectedEmoji,
        onEmojiPickerLoaded: onEmojiPickerLoaded,
        disableEmoji: userOffline || !!isDraftLockedForEditing,
        contentId: contentId,
        isTitleDisabled: isTitleDisabled,
        onUpdateStartEmoji: onUpdateStartEmoji,
        onUpdateEndEmoji: onUpdateEndEmoji,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        contentType: contentType,
        isAutoPageEmojiEligible: isAutoPageEmojiEligible,
        emojiTitleDiscovered: emojiTitleDiscovered,
        isSmartCreate: isSmartCreate
    }));
};












var $jkVM2 = parcelRequire("jkVM2");


var $ep3mz = parcelRequire("ep3mz");


var $38qvz = parcelRequire("38qvz");

const $f8dde916b5af7d9d$export$826c215475ad6cbb = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, hasContentState: hasContentState, contentType: contentType, userOffline: userOffline, setIsContentStateButtonFocused: setIsContentStateButtonFocused, setIsContentStateMenuOpen: setIsContentStateMenuOpen, floatingToolbarButtonStyle: floatingToolbarButtonStyle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isKnowledgeBaseSpace: isKnowledgeBaseSpace } = (0, $38qvz.useSpaceType)({
        spaceKey: spaceKey
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateButtonClicked',
                source: 'editorContentStateButton'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateButtonHovered',
                source: 'editorContentStateButton'
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        setIsContentStateButtonFocused(true);
    }, [
        setIsContentStateButtonFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        setIsContentStateButtonFocused(false);
    }, [
        setIsContentStateButtonFocused
    ]);
    // only want to show hover button if we don't have a content state and if not in a knowledge base space
    // otherwise it will be next to the full-width button
    return !hasContentState && !isKnowledgeBaseSpace ? // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "content-state-button-wrapper",
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkVM2.EditorContentState), {
        contentId: contentId,
        contentType: contentType,
        userOffline: userOffline,
        onContentStateMenuToggle: setIsContentStateMenuOpen,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        isViewMode: false
    })) : null;
});



var $gektR = parcelRequire("gektR");


var $kSwu1 = parcelRequire("kSwu1");





var $7ZB0A = parcelRequire("7ZB0A");


var $lpNn5 = parcelRequire("lpNn5");


var $etoPX = parcelRequire("etoPX");


var $9XB2W = parcelRequire("9XB2W");







const $27a594aa59e1555a$var$i18n = (0, $kSwu1.defineMessages)({
    suggestTitleLabel: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.label",
        defaultMessage: "Suggest title"
    },
    suggestTitleTooltipWhenDocEmpty: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.empty-document.tooltip",
        defaultMessage: "Page cannot be empty"
    },
    suggestTitleTooltipWhenLiveDocEmpty: {
        id: "title-area-content-components.toolbar-above-title.suggest-title-button.empty-live-document.tooltip",
        defaultMessage: "Doc cannot be empty"
    }
});
const $27a594aa59e1555a$export$7cbd5d08127bc63b = ()=>{
    const toolbarButtonRef = (0, $cozmU.useRef)(null);
    const getTargetEditorId = ()=>{
        const editors = Array.from(toolbarButtonRef.current?.closest('.ak-editor-content-area')?.querySelectorAll('.ProseMirror') ?? []).filter((editor)=>!editor.closest('[data-editor-popup]'));
        return editors[0]?.dataset.editorId;
    };
    return {
        toolbarButtonRef: toolbarButtonRef,
        getTargetEditorId: getTargetEditorId
    };
};
const $27a594aa59e1555a$export$dcb5614dfa43cea0 = ({ floatingToolbarButtonStyle: floatingToolbarButtonStyle, isEditorEmpty: isEditorEmpty, userOffline: userOffline, isDraftLockedForEditing: isDraftLockedForEditing, onSuggestTitleClickedRef: onSuggestTitleClickedRef, willAISuggestEmoji: willAISuggestEmoji })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { toolbarButtonRef: toolbarButtonRef, getTargetEditorId: getTargetEditorId } = $27a594aa59e1555a$export$7cbd5d08127bc63b();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleClick = ()=>{
        const targetEditorId = getTargetEditorId();
        if (targetEditorId) {
            onSuggestTitleClickedRef?.current?.();
            (0, $9XB2W.eventHub).publishToEditor({
                event: 'start prompt',
                data: {
                    targetEditorId: targetEditorId,
                    adjustSelection: 'fullDocument',
                    analyticSourceId: 'confluenceTitleToolbar',
                    prompt: 'suggest title in confluence title toolbar',
                    willAISuggestEmoji: willAISuggestEmoji
                }
            });
        }
    };
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        ref: toolbarButtonRef,
        isDisabled: Boolean(userOffline) || Boolean(isEditorEmpty) || Boolean(isDraftLockedForEditing),
        appearance: "subtle",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...floatingToolbarButtonStyle
        },
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            label: "",
            size: "xxsmall",
            appearance: "neutral"
        })
    }, intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleLabel));
    return isEditorEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleTooltipWhenLiveDocEmpty) : intl.formatMessage($27a594aa59e1555a$var$i18n.suggestTitleTooltipWhenDocEmpty),
        position: "top-start"
    }, button) : button;
};


/* AlignmentComponent.tsx generated by @compiled/babel-plugin v3.0.1 */ 












var $7sJoX = parcelRequire("7sJoX");


var $f922E = parcelRequire("f922E");


var $bH62g = parcelRequire("bH62g");





var $kz1Yj = parcelRequire("kz1Yj");





var $3vgx3 = parcelRequire("3vgx3");


var $9erVg = parcelRequire("9erVg");


var $is1T6 = parcelRequire("is1T6");











var $aV3a0 = parcelRequire("aV3a0");

const $315ee4abb467f669$var$dropdownContainerStyles = (0, $buxP3.xcss)({
    paddingRight: 'space.075',
    paddingLeft: 'space.075'
});
const $315ee4abb467f669$var$dropdownMenuStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $315ee4abb467f669$var$IconStyles = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0jFU0VUofl _39xV02Uofl _2mpnYbcjp5 _10DACs2ADO _0eQLG7YbGa",
            __cmplp.isSelected ? "_30huDKmcMy" : "_30huDKYbGa",
            __cmplp.className
        ])
    });
});
const $315ee4abb467f669$var$i18n = (0, $kSwu1.defineMessages)({
    leftAlignmentIconLabel: {
        id: "title-area-content-components.toolbar-above-title.left-alignment-icon.label",
        defaultMessage: "Align Left"
    },
    centerAlignmentIconLabel: {
        id: "title-area-content-components.toolbar-above-title.center-alignment-icon.label",
        defaultMessage: "Align Center"
    },
    dropdownMenuLeftAlignedIconLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-left-aligned-icon.label",
        defaultMessage: "Left Aligned"
    },
    dropdownMenuCenterAlignedIconLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-center-aligned-icon.label",
        defaultMessage: "Center Aligned"
    },
    dropdownMenuAlignmentMenuLabel: {
        id: "title-area-content-components.toolbar-above-title.dropdown-menu-alignment-icon.label",
        defaultMessage: "Select for alignment options"
    },
    headerAlignmentTooltip: {
        id: "title-area-content-components.toolbar-above-title.header-alignment-tooltip",
        defaultMessage: "Header alignment"
    },
    leftAlignHeadingTooltip: {
        id: "title-area-content-components.toolbar-above-title.left-align-heading-tooltip",
        defaultMessage: "Left align header"
    },
    centerAlignHeadingTooltip: {
        id: "title-area-content-components.toolbar-above-title.center-align-heading-tooltip",
        defaultMessage: "Center align header"
    }
});
const $315ee4abb467f669$export$ed732f9c06c51576 = ({ alignmentButtonContainer: alignmentButtonContainer, userOffline: userOffline, isDraftLockedForEditing: isDraftLockedForEditing, createAnalyticsEvent: createAnalyticsEvent, flags: flags, contentType: contentType, alignmentButtonState: alignmentButtonState, coverPictureState: coverPictureState, contentId: contentId, setIsAlignmentDropdownOpen: setIsAlignmentDropdownOpen, isAlignmentDropdownOpen: isAlignmentDropdownOpen })=>{
    const intl = (0, $kSwu1.useIntl)();
    const updateAlignmentState = alignmentButtonState?.toggleAlignmentButton;
    const updateCoverPictureWidthState = coverPictureState?.toggleCoverPictureWidthButton;
    const { updatePageTitleProperty: updatePageTitleProperty, isUpdatingAlignment: isUpdatingAlignment } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        updateAlignmentState: updateAlignmentState,
        updateCoverPictureWidthState: updateCoverPictureWidthState,
        contentType: contentType,
        flags: flags
    });
    const createAlignmentButtonAnalytics = (0, $cozmU.useCallback)((alignment)=>{
        const alignmentName = alignment.charAt(0).toUpperCase() + alignment.slice(1);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                source: `${alignment}AlignmentButton`,
                actionSubject: 'button',
                actionSubjectId: `pageTitle${alignmentName}AlignButton`
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onAlignmentButtonClick = async (alignment)=>{
        if (alignmentButtonContainer.state.alignmentButtonState === alignment || isUpdatingAlignment) // don't mutate state since it's the current state or it's already trying to mutate the state
        return;
        alignmentButtonContainer.setIsUpdatingAlignment(true);
        alignmentButtonContainer.toggleAlignmentButton(alignment);
        await updatePageTitleProperty(JSON.stringify({
            titleLayoutAlignment: alignment
        }));
        alignmentButtonContainer.setIsUpdatingAlignment(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02HMkp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: intl.formatMessage($315ee4abb467f669$var$i18n.headerAlignmentTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                    space: "space.075"
                }, alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                    label: intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuLeftAlignedIconLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                    label: intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuCenterAlignedIconLabel)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    size: "small"
                })),
                ref: triggerRef,
                ...(0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? {
                    'aria-label': `${intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuAlignmentMenuLabel)}: ${alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuLeftAlignedIconLabel) : intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuCenterAlignedIconLabel)}`
                } : {
                    label: `${intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuAlignmentMenuLabel)}: ${alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuLeftAlignedIconLabel) : intl.formatMessage($315ee4abb467f669$var$i18n.dropdownMenuCenterAlignedIconLabel)}`
                },
                testId: `${alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT ? 'left' : 'center'}-alignment-dropdown-menu`,
                appearance: "subtle",
                shouldFitContainer: true,
                isDisabled: userOffline || !!isDraftLockedForEditing
            })),
        spacing: "compact",
        onOpenChange: ()=>setIsAlignmentDropdownOpen(!isAlignmentDropdownOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        columnGap: "space.025",
        xcss: $315ee4abb467f669$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($315ee4abb467f669$var$IconStyles, {
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($315ee4abb467f669$var$i18n.leftAlignHeadingTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            createAlignmentButtonAnalytics((0, $jVylI.TitleAlignmentType).LEFT.toLowerCase());
            onAlignmentButtonClick((0, $jVylI.TitleAlignmentType).LEFT);
        },
        isDisabled: userOffline || alignmentButtonContainer.state.isUpdatingAlignment,
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).LEFT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
        label: intl.formatMessage($315ee4abb467f669$var$i18n.leftAlignmentIconLabel),
        testId: "left-alignment-button"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($315ee4abb467f669$var$IconStyles, {
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($315ee4abb467f669$var$i18n.centerAlignHeadingTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            createAlignmentButtonAnalytics((0, $jVylI.TitleAlignmentType).CENTER.toLowerCase());
            onAlignmentButtonClick((0, $jVylI.TitleAlignmentType).CENTER);
        },
        isDisabled: userOffline || alignmentButtonContainer.state.isUpdatingAlignment,
        isSelected: alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
        label: intl.formatMessage($315ee4abb467f669$var$i18n.centerAlignmentIconLabel),
        testId: "center-alignment-button"
    }))))))));
};


/* DictationButton.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @compiled/no-keyframes-tagged-template-expression, @atlaskit/design-system/no-keyframes-tagged-template-expression, @atlaskit/ui-styling-standard/no-unsafe-values, no-unused-vars */ /**
 * @experimental
 * This component is a prototype and is not ready to be used in production.
 */ 















var $ad7Ou = parcelRequire("ad7Ou");


var $hjuSl = parcelRequire("hjuSl");




// Pulse animation for recording indicator
const $899989bd7fab0eeb$var$pulseAnimation = null;
const $899989bd7fab0eeb$var$dictationButtonStyles = {
    recordingDotFallback: "_0bjKvD715P _2fBhteNMg0 _1mT5xdWVPG _2IhTondnbC _4ApkO2A17z _39xV02UNDJ _0jFU0VUNDJ _0KLXruqsXs",
    recordingDotUpdated: "_0bjKvDS5Zs _2fBhteNMg0 _1mT5xdWVPG _2IhTondnbC _4ApkO2A17z _39xV02UNDJ _0jFU0VUNDJ _0KLXruqsXs",
    microphoneContainer: "_1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _0adFHs1Y8M"
};
const $899989bd7fab0eeb$var$i18n = (0, $kSwu1.defineMessages)({
    dictationLabel: {
        id: "title-area-content-components.toolbar-above-title.dictation-button.label",
        defaultMessage: "Dictation"
    },
    voiceTypingText: {
        id: "title-area-content-components.toolbar-above-title.dictation-button.text",
        defaultMessage: "Voice typing"
    }
}); // Helper function to directly test if speech recognition is available
const $899989bd7fab0eeb$var$checkSpeechRecognitionSupport = ()=>{
    if (typeof window === 'undefined') return false; // First check if the APIs exist
    const hasSpeechRecognition = 'SpeechRecognition' in window;
    const hasWebkitSpeechRecognition = 'webkitSpeechRecognition' in window; // Try to create an instance to truly confirm it works
    try {
        if (hasWebkitSpeechRecognition) {
            // Try to create a webkitSpeechRecognition instance
            const WebkitSpeechRecognition = window.webkitSpeechRecognition;
            if (WebkitSpeechRecognition) {
                const recognition = new WebkitSpeechRecognition();
                return !!recognition;
            }
        } else if (hasSpeechRecognition) {
            // Try to create a SpeechRecognition instance
            const SpeechRecognition = window.SpeechRecognition;
            if (SpeechRecognition) {
                const recognition = new SpeechRecognition();
                return !!recognition;
            }
        }
    } catch (error) {}
    return false;
};
const $899989bd7fab0eeb$export$9c8a41ef2f037f7c = ({ userOffline: userOffline, isDraftLockedForEditing: isDraftLockedForEditing })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDictating, setIsDictating] = (0, $cozmU.useState)(false);
    const [isSupported, setIsSupported] = (0, $cozmU.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)('');
    const recognitionRef = (0, $cozmU.useRef)(null);
    const isMounted = (0, $cozmU.useRef)(false);
    const floatingButtonRef = (0, $cozmU.useRef)(null); // Add ref for tracking session duration
    const sessionStartTimeRef = (0, $cozmU.useRef)(0); // Track the last inserted transcript to avoid duplicates
    const lastInsertedTranscriptRef = (0, $cozmU.useRef)(''); // Generate unique ID for this component instance to avoid conflicts
    const componentId = (0, $cozmU.useId)();
    const componentIdRef = (0, $cozmU.useRef)(`dictation-floating-button${componentId}`); // Check if browser supports speech recognition after component mounts
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true; // Use the helper function to check support
        const supported = $899989bd7fab0eeb$var$checkSpeechRecognitionSupport();
        setIsSupported(supported);
        if (!supported) setErrorMessage('Speech recognition not supported in this browser');
         // Create the floating button element when component mounts
        if (typeof document !== 'undefined') {
            // Create floating button with unique ID
            const buttonElement = document.createElement('div');
            buttonElement.setAttribute('id', componentIdRef.current);
            buttonElement.setAttribute('data-testid', 'dictation-floating-button');
            buttonElement.setAttribute('role', 'button');
            buttonElement.setAttribute('aria-label', 'Stop voice typing');
            buttonElement.setAttribute('tabindex', '0');
            document.body.appendChild(buttonElement);
            floatingButtonRef.current = buttonElement;
        }
        return ()=>{
            isMounted.current = false; // Remove the elements when component unmounts
            if (floatingButtonRef.current && document.body.contains(floatingButtonRef.current)) document.body.removeChild(floatingButtonRef.current);
        };
    }, []); // Define stopDictation function
    const stopDictation = (0, $cozmU.useCallback)(()=>{
        if (recognitionRef.current) try {
            recognitionRef.current.stop();
        } catch (error) {} finally{
            recognitionRef.current = null;
            setIsDictating(false); // Hide the button
            if (floatingButtonRef.current) floatingButtonRef.current.style.display = 'none';
             // Calculate session duration in seconds
            if (sessionStartTimeRef.current > 0) {
                const sessionDurationSeconds = Math.round((Date.now() - sessionStartTimeRef.current) / 1000); // Send analytics event with session duration
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'completed',
                        actionSubject: 'dictationSession',
                        actionSubjectId: 'voiceTyping',
                        attributes: {
                            sessionDurationSeconds: sessionDurationSeconds
                        }
                    }
                }).fire(); // Reset session start time
                sessionStartTimeRef.current = 0;
            }
        }
    }, [
        createAnalyticsEvent
    ]); // Function to insert final text into the editor
    const insertText = (0, $cozmU.useCallback)((text)=>{
        try {
            const selection = window.getSelection();
            if (!selection || !selection.rangeCount) return;
            const range = selection.getRangeAt(0); // Insert final text directly
            range.deleteContents(); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const textNode = document.createTextNode(text);
            range.insertNode(textNode); // Move cursor to end of inserted text
            try {
                if (textNode.parentNode) {
                    range.selectNode(textNode);
                    range.collapse(false); // collapse to end
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            } catch (e) {}
        } catch (error) {}
    }, []); // Define startDictation function
    const startDictation = (0, $cozmU.useCallback)(()=>{
        // Double-check we're in a browser environment and API is supported
        if (typeof window === 'undefined') {
            setErrorMessage('Not in a browser environment');
            setIsDictating(false);
            return;
        } // Re-check support at runtime
        const supported = $899989bd7fab0eeb$var$checkSpeechRecognitionSupport();
        if (!supported) {
            setErrorMessage('Speech recognition not supported in this browser');
            setIsDictating(false);
            return;
        }
        try {
            // Record start time when dictation begins
            sessionStartTimeRef.current = Date.now(); // Get the right speech recognition constructor
            const SpeechRecognitionAPI = window.webkitSpeechRecognition || window.SpeechRecognition;
            if (!SpeechRecognitionAPI) {
                setErrorMessage('Speech Recognition API not found');
                setIsDictating(false);
                return;
            } // Create a new recognition instance
            const recognition = new SpeechRecognitionAPI(); // Configure the recognition - disable interim results for simpler handling
            recognition.continuous = true;
            recognition.interimResults = false; // Only show final recognized text
            recognition.lang = 'en-US'; // Default to English
            // Reset transcript tracking when starting new dictation
            lastInsertedTranscriptRef.current = ''; // Set up the event handlers
            recognition.onresult = (event)=>{
                if (!isMounted.current) return; // Get the last result (most complete transcript)
                // Since interimResults is false, all results should be final
                const lastResultIndex = event.results.length - 1;
                if (lastResultIndex < 0) return;
                const lastResult = event.results[lastResultIndex];
                if (!lastResult.isFinal) return;
                const newTranscript = lastResult[0].transcript.trim();
                const lastInserted = lastInsertedTranscriptRef.current.trim(); // Extract only the NEW portion by comparing with what we've already inserted
                if (newTranscript.startsWith(lastInserted)) {
                    const newText = newTranscript.slice(lastInserted.length).trim();
                    if (newText) {
                        // Update the tracker
                        lastInsertedTranscriptRef.current = newTranscript; // Insert only the new portion
                        insertText(`${newText} `);
                    }
                } else if (newTranscript !== lastInserted) {
                    // Edge case: transcript doesn't start with our last inserted text
                    // This could happen if the API resets or there's a mismatch
                    // Insert the whole thing and update our tracker
                    lastInsertedTranscriptRef.current = newTranscript;
                    insertText(`${newTranscript} `);
                }
            }; // Add network error handling
            recognition.onerror = (event)=>{
                if (!isMounted.current) return; // Handle network errors specifically
                if (event.error === 'network') {
                    setErrorMessage('Network error. Please check your connection and try again.'); // Attempt to restart after a network error
                    if (isDictating) setTimeout(()=>{
                        if (isMounted.current && isDictating) try {
                            recognition.start();
                        } catch (retryError) {
                            setIsDictating(false);
                            setErrorMessage('Failed to restart after network error');
                        }
                    }, 2000); // Give network time to recover
                } else {
                    // Original error handling
                    const errorMsg = `Recognition error: ${event.error || 'unknown error'}`;
                    setErrorMessage(errorMsg);
                    setIsDictating(false); // If permission denied, show more specific message
                    if (event.error === 'not-allowed' || event.error === 'permission-denied') {
                        const permissionMsg = 'Microphone access denied. Please allow microphone access in your browser settings.';
                        setErrorMessage(permissionMsg);
                    }
                }
            }; // Add a robust retry mechanism to onend handler
            recognition.onend = ()=>{
                if (!isMounted.current) return; // If we're supposed to be dictating but the recognition stopped, restart it
                if (isDictating) {
                    // Track retry attempts
                    const maxRetries = 3;
                    let retryCount = 0;
                    const attemptRestart = ()=>{
                        try {
                            // Restart recognition immediately
                            recognition.start();
                        } catch (error) {
                            retryCount++;
                            if (retryCount < maxRetries) // If immediate restart fails, try with exponential backoff
                            setTimeout(()=>{
                                if (isMounted.current && isDictating) attemptRestart();
                            }, Math.min(100 * Math.pow(2, retryCount), 2000)); // Exponential backoff with max 2s
                            else {
                                setIsDictating(false);
                                setErrorMessage('Connection issue. Please try again.');
                            }
                        }
                    };
                    attemptRestart();
                }
            }; // Start listening
            recognition.start(); // Show the floating button
            if (floatingButtonRef.current) floatingButtonRef.current.style.display = 'flex';
             // Save the recognition instance to the ref for later access
            recognitionRef.current = recognition;
        } catch (error) {
            if (error instanceof Error) {
                const errorMsg = `Failed to start dictation: ${error.message}`;
                setErrorMessage(errorMsg);
            } else {
                const errorMsg = 'Failed to start dictation: unknown error';
                setErrorMessage(errorMsg);
            }
            setIsDictating(false);
        }
    }, [
        isDictating,
        insertText
    ]);
    // Update the button when dictation state changes
    (0, $cozmU.useEffect)(()=>{
        if (!floatingButtonRef.current) return;
        const button = floatingButtonRef.current;
        if (isDictating) {
            // Find the object sidebar container
            const sidebarContainer = document.querySelector('[data-testid="object-sidebar-container"]'); // Set button styles
            Object.assign(button.style, {
                position: 'relative',
                width: '48px',
                height: '48px',
                borderRadius: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? "var(--ds-radius-full, 9999px)" : '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                zIndex: '1',
                background: "var(--ds-background-danger-bold, #C9372C)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                cursor: 'pointer',
                marginBottom: "var(--ds-space-200, 16px)",
                marginTop: "var(--ds-space-negative-100, -8px)"
            }); // Append the button to the sidebar container (renders below Rovo button)
            if (sidebarContainer) {
                button.setAttribute('data-testid', 'dictation-floating-button-sidebar');
                sidebarContainer.appendChild(button);
            } else {
                button.setAttribute('data-testid', 'dictation-floating-button');
                Object.assign(button.style, {
                    position: 'fixed',
                    bottom: '8px',
                    right: '24px',
                    marginTop: '0'
                });
            } // Set content with microphone icon
            button.innerHTML = `
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M12 15C14.21 15 16 13.21 16 11V5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5V11C8 13.21 9.79 15 12 15Z" fill="white"/>
					<path d="M19 11H17.3C17.3 14.07 14.76 16.61 11.69 16.61L11.69 16.61C8.61 16.61 6.07 14.07 6.07 11H4.38C4.38 14.62 7 17.6 10.5 18.24V21H13.5V18.24C17 17.6 19 14.62 19 11Z" fill="white"/>
				</svg>
			`; // Add tooltip title
            button.setAttribute('title', 'Click to stop dictation'); // Add click event listener
            button.onclick = stopDictation; // Add keyboard support (Enter and Space keys)
            const handleKeyDown = (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    stopDictation();
                }
            };
            button.addEventListener('keydown', handleKeyDown); // Cleanup function
            return ()=>{
                button.removeEventListener('keydown', handleKeyDown);
            };
        } else {
            // Hide the button when not dictating
            button.style.display = 'none';
            button.setAttribute('data-testid', 'dictation-floating-button');
        }
    }, [
        isDictating,
        stopDictation
    ]);
    // Stop dictation immediately when user goes offline
    (0, $cozmU.useEffect)(()=>{
        if ((userOffline || isDraftLockedForEditing) && isDictating) stopDictation();
    }, [
        userOffline,
        isDraftLockedForEditing,
        isDictating,
        stopDictation
    ]);
    const handleDictationClick = (0, $cozmU.useCallback)(()=>{
        // Reset any error messages when trying again
        setErrorMessage(''); // Determine action based on current state
        const willStart = !isDictating; // Fire analytics event
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: willStart ? 'started' : 'stopped',
                source: 'dictationButton',
                actionSubject: 'pageTitle',
                actionSubjectId: 'dictationButton'
            }
        }).fire(); // Perform action immediately without race conditions
        if (willStart) {
            setIsDictating(true); // Use setTimeout to allow state update to complete before starting
            setTimeout(()=>{
                startDictation();
            }, 0);
        } else stopDictation();
    }, [
        createAnalyticsEvent,
        isDictating,
        startDictation,
        stopDictation
    ]); // Clean up the recognition object when the component unmounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (recognitionRef.current) try {
                recognitionRef.current.stop();
            } catch (error) {}
        };
    }, []); // Get a more specific tooltip message based on state
    const getTooltipMessage = ()=>{
        if (errorMessage) return errorMessage;
        if (!isSupported) return 'Speech recognition not supported in this browser';
        return isDictating ? 'Stop Voice Typing' : 'Start Voice Typing';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "dictation-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: getTooltipMessage(),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleDictationClick,
        isDisabled: userOffline || !!isDraftLockedForEditing,
        testId: "dictation-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $899989bd7fab0eeb$var$dictationButtonStyles.microphoneContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjuSl))), {
        label: intl.formatMessage($899989bd7fab0eeb$var$i18n.dictationLabel),
        color: isDictating ? "var(--ds-icon-danger, #C9372C)" : undefined
    }), isDictating && ((0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "recording-indicator",
        className: (0, $hekY6.default)([
            $899989bd7fab0eeb$var$dictationButtonStyles.recordingDotUpdated
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "recording-indicator",
        className: (0, $hekY6.default)([
            $899989bd7fab0eeb$var$dictationButtonStyles.recordingDotFallback
        ])
    }))), intl.formatMessage($899989bd7fab0eeb$var$i18n.voiceTypingText))));
};


const $9da45ee98b721761$var$toolbarAboveTitleBoxStylesBase = (0, $buxP3.xcss)({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 'space.200'
});
const $9da45ee98b721761$var$toolbarAboveTitleLeftAlignmentStyles = (0, $buxP3.xcss)({
    alignItems: 'start'
});
const $9da45ee98b721761$var$toolbarAboveTitleCenterAlignmentStyles = (0, $buxP3.xcss)({
    alignItems: 'center'
});
const $9da45ee98b721761$var$toolbarAboveTitleHiddenStyles = (0, $buxP3.xcss)({
    overflowX: 'hidden'
});
const $9da45ee98b721761$var$coverPictureAndButtonFixedWidthHeightStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    height: `${(0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT)}px`
});
const $9da45ee98b721761$var$coverPictureAndButtonFullWidthHeightStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    height: `${(0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE)}`
});
const $9da45ee98b721761$var$toolbarStyle = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to align this to the design system
    marginTop: '-22px',
    width: '100%',
    marginBottom: 'space.0'
});
const $9da45ee98b721761$var$toolbarListItemStyles = (0, $buxP3.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $9da45ee98b721761$var$rightControlsGroupXcss = (0, $buxP3.xcss)({
    display: 'flex',
    columnGap: 'space.0'
});
const $9da45ee98b721761$var$ToolbarButtonsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isTitleCenterAligned: isTitleCenterAligned, shouldShowToolbar: shouldShowToolbar, isReadOnly: isReadOnly, hasEmoji: hasEmoji, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1LMyvKOiJt _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2uo31flfZc _0bjKvDzXzM _4FKVYE1Y8M _23rrnH9tAK _1mT5xdRAKS _0jFU0VE6Kk _39xV02E6Kk _2Zuz6QdnbC _42Yu6Bbhqd _3iDTPbQ4SZ _17lj8p1Y8M _3qgovSPgdg _3ge4zmnQyn",
            (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isTitleCenterAligned ? "_4xdlr0DIqT" : "_4xdlr0IZbP",
            __cmplp.shouldShowToolbar ? "_1YKVNs7dHp" : "_1YKVNsj54u",
            __cmplp.isReadOnly ? "_0fKRyPnQyn" : "_0fKRyPYvD1",
            __cmplp.hasCoverPicture && (__cmplp.hasEmoji || __cmplp.isSpaceOverview ? "_313842p0Oa" : "_313842NHnM"),
            __cmplp.className
        ])
    });
}); // Fallback wrapper when FG is off: static non-token border/radius values
const $9da45ee98b721761$var$ToolbarButtonsWrapperFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isTitleCenterAligned: isTitleCenterAligned, shouldShowToolbar: shouldShowToolbar, isReadOnly: isReadOnly, hasEmoji: hasEmoji, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1LMyvKOiJt _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2uo31flfZc _0bjKvD4Y4b _4FKVYE1Y8M _23rrnH9tAK _1mT5xdRAKS _0jFU0VE6Kk _39xV02E6Kk _2Zuz6QdnbC _42Yu6Bbhqd _3iDTPbQ4SZ _17lj8p1Y8M _3qgovSYbGa _3ge4zmnQyn",
            (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isTitleCenterAligned ? "_4xdlr0DIqT" : "_4xdlr0IZbP",
            __cmplp.shouldShowToolbar ? "_1YKVNs7dHp" : "_1YKVNsj54u",
            __cmplp.isReadOnly ? "_0fKRyPnQyn" : "_0fKRyPYvD1",
            __cmplp.hasCoverPicture && (__cmplp.hasEmoji || __cmplp.isSpaceOverview ? "_313842p0Oa" : "_313842NHnM"),
            __cmplp.className
        ])
    });
});
const $9da45ee98b721761$var$floatingToolbarButtonStyle = {
    height: '32px',
    alignItems: 'center'
};
const $9da45ee98b721761$export$1ba161aab679566b = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, userOffline: userOffline, isUnpublishedDraft: isUnpublishedDraft, isTitleDisabled: isTitleDisabled, isCoverPictureModalOpen: isCoverPictureModalOpen, hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused, setSelectedEmoji: setSelectedEmoji, onEmojiPickerLoaded: onEmojiPickerLoaded, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isEmojiButtonFocused: isEmojiButtonFocused, hasEmoji: hasEmoji, contentType: contentType, isPublishingContent: isPublishingContent, hasContentState: hasContentState, isSpaceOverview: isSpaceOverview, contentStateState: contentStateState, isTitleCenterAligned: isTitleCenterAligned, alignmentButtonState: alignmentButtonState, coverPictureState: coverPictureState, isSecondEmojiPickerOpen: isSecondEmojiPickerOpen, flags: flags, isReadOnly: isReadOnly, isEditorEmpty: isEditorEmpty, coverPictureWidth: coverPictureWidth, spaceKey: spaceKey, contentComponentsDisabled: contentComponentsDisabled, isDraftLockedForEditing: isDraftLockedForEditing, isStatusDisconnected: isStatusDisconnected, coverImageWidthCached: coverImageWidthCached, isUnsplash: isUnsplash, hideSuggestedTitle: hideSuggestedTitle = false, hideContentState: hideContentState = false, hideEditorAppearanceButton: hideEditorAppearanceButton = false, hideAlignmentButton: hideAlignmentButton = false, hideContentModeButton: hideContentModeButton = false, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isAutoPageEmojiEligible: isAutoPageEmojiEligible, emojiTitleDiscovered: emojiTitleDiscovered, isSmartCreate: isSmartCreate, onSuggestTitleClickedRef: onSuggestTitleClickedRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const hasCoverPictureOrUploadingPicture = hasCoverPicture || isUploadingPicture;
    const willAISuggestEmoji = (0, $6mKj3.isExperimentEnabled)('confluence_suggested_emojis_for_title_generation') && !hasEmoji; // Hide toolbar when live page is rendered in preview panel
    const shouldHideToolbarInPreviewPanel = isLivePage && (0, $eToX6.isInPreviewPanel)();
    const getToolbarTestId = ()=>{
        if (shouldHideToolbarInPreviewPanel) return 'toolbar-above-title-wrapper-hidden';
        if (isTitleCenterAligned) return 'toolbar-above-title-wrapper-centered';
        return 'toolbar-above-title-wrapper';
    };
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isFixedWidth = coverImageWidthCached && isServerPlaceholder ? coverImageWidthCached === (0, $jVylI.COVERPICTUREWIDTH).FIXED : coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const [isContentStateButtonFocused, setIsContentStateButtonFocused] = (0, $cozmU.useState)(false);
    const [isContentStateMenuOpen, setIsContentStateMenuOpen] = (0, $cozmU.useState)(false);
    const [isAlignmentDropdownOpen, setIsAlignmentDropdownOpen] = (0, $cozmU.useState)(false);
    const [isAppearanceDropdownOpen, setIsAppearanceDropdownOpen] = (0, $cozmU.useState)(false); // Tracks if any of the pickers, dropdowns, or hover buttons are open or focused
    const onlineShouldShowToolbar = isSecondEmojiPickerOpen || isAddHeaderImageButtonFocused || isEmojiButtonFocused || isContentStateButtonFocused || isContentStateMenuOpen || isCoverPictureModalOpen || isAlignmentDropdownOpen || isAppearanceDropdownOpen && ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true));
    const [shouldShowToolbarPrevOnlineValue, setShouldShowToolbarPrevOnlineValue] = (0, $cozmU.useState)(onlineShouldShowToolbar);
    (0, $cozmU.useEffect)(()=>{
        if (!userOffline) setShouldShowToolbarPrevOnlineValue(onlineShouldShowToolbar);
    }, [
        userOffline,
        onlineShouldShowToolbar
    ]);
    const shouldShowToolbar = !isReadOnly && (userOffline ? shouldShowToolbarPrevOnlineValue : onlineShouldShowToolbar);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Whenever we leave the editor, we need to clean up and reset the content state container values on unmount,
            // otherwise when the user opens editor, previous values are incorrectly persisted (could also do this in breadcrumbs but chose here)
            contentStateState.resetToDefaults();
            coverPictureState.resetToDefaults();
            alignmentButtonState?.resetToDefaults();
        };
    }, [
        contentStateState,
        coverPictureState,
        alignmentButtonState
    ]);
    const editorAppearanceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RPbY.EditorAppearanceButtonNext), {
        contentId: contentId,
        disabled: !!contentComponentsDisabled,
        isStatusDisconnected: !!isStatusDisconnected,
        setIsAppearanceDropdownOpen: setIsAppearanceDropdownOpen,
        isAppearanceDropdownOpen: isAppearanceDropdownOpen
    });
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({
        isFixedWidth: isFixedWidth
    });
    const coverImageWidth = isFixedWidth ? (0, $75Ax4.COVER_IMAGE_FIXED_WIDTH) : width;
    const dynamicCoverImageHeight = isFixedWidth ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : (0, $3WPGR.getDynamicCoverImageHeight)(coverImageWidth);
    const [coverPictureAndButtonWrapperHeight, setCoverPictureAndButtonWrapperHeight] = (0, $cozmU.useState)(dynamicCoverImageHeight);
    const coverPicAndButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42b1c9f0169a6e1e$export$bd378463497634f0), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        hasCoverPicture: hasCoverPicture,
        isUploadingPicture: isUploadingPicture,
        hasContentState: hasContentState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: $9da45ee98b721761$var$floatingToolbarButtonStyle,
        isFixedWidthImageOption: isFixedWidth,
        updateHeight: setCoverPictureAndButtonWrapperHeight,
        currentHeight: coverPictureAndButtonWrapperHeight,
        isReadOnly: isReadOnly,
        isDraftLockedForEditing: isDraftLockedForEditing,
        spaceKey: spaceKey,
        isUnsplash: isUnsplash,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        width: width,
        coverImageWidth: coverImageWidth,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId,
        aiHeaderImageError: aiHeaderImageError,
        generateAIHeaderImage: generateAIHeaderImage,
        setAIHeaderImageStatus: setAIHeaderImageStatus,
        isSmartCreate: isSmartCreate
    });
    const onContentStateUpdatedSubscription = (0, $cozmU.useCallback)((_, data)=>{
        const { contentStateUpdated: contentStateUpdated } = data || {};
        try {
            const contentState = JSON.parse(contentStateUpdated?.value);
            const parsedContentState = contentState?.contentState; // JSON.parse returns numeric ids as numbers, but the rest of the codebase
            // uses string ids (matching the GraphQL ID scalar type). Coerce to string
            // to prevent strict equality mismatches in ContentStateMenuV2.
            if (parsedContentState?.id != null && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) parsedContentState.id = String(parsedContentState.id);
            contentStateState.setContentState(parsedContentState);
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        contentStateState
    ]);
    const onContentStateDeletedSubscription = (0, $cozmU.useCallback)(()=>{
        contentStateState.setContentState(null);
    }, [
        contentStateState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ToolbarAboveTitleContentStateUpdated',
        delta: 'contentStateUpdated',
        contentId: contentId,
        contentType: contentType || 'page',
        onDataReceived: onContentStateUpdatedSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'TitleAreaContentComponentsContentStateDeleted',
        delta: 'contentStateDeleted',
        contentId: contentId,
        contentType: contentType || 'page',
        onDataReceived: onContentStateDeletedSubscription
    });
    const coverPicAndButtonAboveToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $9da45ee98b721761$var$toolbarStyle,
            isFixedWidth ? $9da45ee98b721761$var$coverPictureAndButtonFixedWidthHeightStyle : $9da45ee98b721761$var$coverPictureAndButtonFullWidthHeightStyle
        ],
        testId: "cover-pic-and-button-wrapper-above-toolbar",
        "data-id": "cover-pic-and-button-wrapper"
    }, coverPicAndButton);
    const coverPicAndButtonInsideToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "cover-pic-and-button-wrapper-inside-toolbar"
    }, coverPicAndButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer)
        ]
    }, (alignmentButtonContainer)=>{
        const ToolbarWrapper = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $9da45ee98b721761$var$ToolbarButtonsWrapper : $9da45ee98b721761$var$ToolbarButtonsWrapperFallback;
        const contentStateToolbarItem = !hideContentState && !hasContentState && !isSpaceOverview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8dde916b5af7d9d$export$826c215475ad6cbb), {
            contentId: contentId,
            hasContentState: hasContentState,
            contentType: contentType,
            userOffline: userOffline,
            setIsContentStateButtonFocused: setIsContentStateButtonFocused,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen,
            floatingToolbarButtonStyle: $9da45ee98b721761$var$floatingToolbarButtonStyle
        })) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                $9da45ee98b721761$var$toolbarAboveTitleBoxStylesBase,
                isTitleCenterAligned ? $9da45ee98b721761$var$toolbarAboveTitleCenterAlignmentStyles : $9da45ee98b721761$var$toolbarAboveTitleLeftAlignmentStyles,
                shouldHideToolbarInPreviewPanel && $9da45ee98b721761$var$toolbarAboveTitleHiddenStyles
            ],
            testId: getToolbarTestId(),
            "data-toolbar-visible": shouldShowToolbar ? 'true' : undefined
        }, hasCoverPictureOrUploadingPicture ? coverPicAndButtonAboveToolbar : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToolbarWrapper, {
            isUploadingPicture: isUploadingPicture,
            hasCoverPicture: hasCoverPicture,
            isTitleCenterAligned: isTitleCenterAligned,
            shouldShowToolbar: shouldShowToolbar,
            hasEmoji: hasEmoji,
            isReadOnly: isReadOnly,
            isSpaceOverview: isSpaceOverview,
            "data-testid": "toolbar-buttons-wrapper"
        }, !hideAlignmentButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $315ee4abb467f669$export$ed732f9c06c51576), {
            alignmentButtonContainer: alignmentButtonContainer,
            userOffline: userOffline,
            isDraftLockedForEditing: isDraftLockedForEditing,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            contentType: contentType,
            alignmentButtonState: alignmentButtonState,
            coverPictureState: coverPictureState,
            contentId: contentId,
            setIsAlignmentDropdownOpen: setIsAlignmentDropdownOpen,
            isAlignmentDropdownOpen: isAlignmentDropdownOpen
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cc701d489c817ee$export$e6ce3311a4d41b7f), {
            contentId: contentId,
            userOffline: userOffline,
            isDraftLockedForEditing: isDraftLockedForEditing,
            isUnpublishedDraft: isUnpublishedDraft,
            isTitleDisabled: isTitleDisabled,
            setSelectedEmoji: setSelectedEmoji,
            onEmojiPickerLoaded: onEmojiPickerLoaded,
            onUpdateStartEmoji: onUpdateStartEmoji,
            onUpdateEndEmoji: onUpdateEndEmoji,
            floatingToolbarButtonStyle: $9da45ee98b721761$var$floatingToolbarButtonStyle,
            contentType: contentType,
            isAutoPageEmojiEligible: isAutoPageEmojiEligible,
            emojiTitleDiscovered: emojiTitleDiscovered,
            isSmartCreate: isSmartCreate
        })), contentStateToolbarItem, hasCoverPictureOrUploadingPicture ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, coverPicAndButtonInsideToolbar), !hideSuggestedTitle && isAIEnabledForContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27a594aa59e1555a$export$dcb5614dfa43cea0), {
            isEditorEmpty: isEditorEmpty,
            floatingToolbarButtonStyle: $9da45ee98b721761$var$floatingToolbarButtonStyle,
            userOffline: userOffline,
            isDraftLockedForEditing: isDraftLockedForEditing,
            onSuggestTitleClickedRef: onSuggestTitleClickedRef,
            willAISuggestEmoji: willAISuggestEmoji
        })), !hideContentModeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $9da45ee98b721761$var$rightControlsGroupXcss,
            testId: "title-toolbar-right-controls-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPcvk.EditorContentModeButton), {
            contentId: contentId,
            disabled: isDraftLockedForEditing,
            isStatusDisconnected: isStatusDisconnected
        }), !hideEditorAppearanceButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "editor-appearance-button-wrapper"
        }, editorAppearanceButton))), (0, $6mKj3.expValEquals)('confluence-dictation-button-on-pages', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "li",
            xcss: $9da45ee98b721761$var$toolbarListItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $899989bd7fab0eeb$export$9c8a41ef2f037f7c), {
            userOffline: userOffline,
            isDraftLockedForEditing: isDraftLockedForEditing
        }))));
    });
});
$9da45ee98b721761$export$1ba161aab679566b.displayName = 'ToolbarAboveTitle';





const $371f4180811f666e$var$TOOLBAR_OPACITY_VAR = '--toolbar-opacity';
const $371f4180811f666e$var$editorTitleWrapperStyles = {
    root: "_39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _4mYWqkdnbC _1uR3DfHZdu",
    paddingTopSpace300: "_0Of8r2NHnM",
    paddingTopSpace0: "_0Of8r2Pgdg",
    topSpacing: "_3138427zWO _0Of8r25zaO",
    paddingBottomSpace300: "_1wydGWNHnM",
    newEditorTitleHoverTopPadding: "_0Of8r2kG2W",
    nativeEmbedLiveDocHoverPadding: "_23rrnH2Top _0Of8r2Pgdg _3RrytgGXk2 _2T6YXJGXk2"
};
const $371f4180811f666e$var$titleBoxStylesAlignSelfCenter = (0, $buxP3.xcss)({
    alignSelf: 'center'
});
const $371f4180811f666e$var$authorBylinePositionRelative = (0, $buxP3.xcss)({
    position: 'relative'
});
const $371f4180811f666e$var$editorTitleBaseStyles = (0, $buxP3.xcss)({
    width: '100%',
    marginTop: 'space.negative.200',
    marginBottom: 'space.400'
});
const $371f4180811f666e$var$editorTitleSmallerMarginBottomBaseStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.300'
});
const $371f4180811f666e$var$EditorTitleWithButtonsWrapper = ({ viewMode: viewMode, isContentTopperComponentPresent: isContentTopperComponentPresent, shouldBylineRenderContentTopper: shouldBylineRenderContentTopper, hasCoverPicture: hasCoverPicture, isInNativeEmbedLiveDoc: isInNativeEmbedLiveDoc, children: children })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ $cozmU.createElement("div" // TODO: Cleanup CSS when cleaning up FG PGXT-8139
    , {
        "data-testid": "editor-title-with-buttons-div",
        ...ssrPlaceholderIdProp,
        className: (0, $hekY6.default)([
            $371f4180811f666e$var$editorTitleWrapperStyles.root,
            viewMode ? $371f4180811f666e$var$editorTitleWrapperStyles.paddingTopSpace300 : $371f4180811f666e$var$editorTitleWrapperStyles.paddingTopSpace0,
            isContentTopperComponentPresent && $371f4180811f666e$var$editorTitleWrapperStyles.topSpacing,
            isContentTopperComponentPresent && shouldBylineRenderContentTopper && $371f4180811f666e$var$editorTitleWrapperStyles.paddingBottomSpace300,
            isContentTopperComponentPresent && !hasCoverPicture && $371f4180811f666e$var$editorTitleWrapperStyles.newEditorTitleHoverTopPadding,
            isInNativeEmbedLiveDoc && !hasCoverPicture && $371f4180811f666e$var$editorTitleWrapperStyles.nativeEmbedLiveDocHoverPadding
        ])
    }, children);
};
$371f4180811f666e$var$EditorTitleWithButtonsWrapper.displayName = 'EditorTitleWithButtonsWrapper';
const $371f4180811f666e$export$860ceec1bc73beeb = ({ contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, isUnpublishedDraft: isUnpublishedDraft, children: editorTitle, isTemplateEditor: isTemplateEditor = false, isTitleCenterAligned: isTitleCenterAligned, viewMode: viewMode, contentTopperComponent: contentTopperComponent, contentClassificationMetadata: contentClassificationMetadata, hasClassification: hasClassification, spaceKey: spaceKey, isEditorEmpty: isEditorEmpty, isTitleAlignmentLoading: isTitleAlignmentLoading, contentComponentsDisabled: contentComponentsDisabled, isDraftLockedForEditing: isDraftLockedForEditing, isStatusDisconnected: isStatusDisconnected, coverPictureState: coverPictureState, title: title, titleAfterBlur: titleAfterBlur, isLivePage: isLivePage, coverImageWidthCached: coverImageWidthCached, hideSuggestedTitle: hideSuggestedTitle = false, hideContentState: hideContentState = false, hideEditorAppearanceButton: hideEditorAppearanceButton = false, hideContentModeButton: hideContentModeButton = false, hideAlignmentButton: hideAlignmentButton = false, pageTitleContent: pageTitleContent, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isAutoPageEmojiEligible: isAutoPageEmojiEligible, emojiTitleDiscovered: emojiTitleDiscovered, onSuggestTitleClickedRef: onSuggestTitleClickedRef, version: version, hasTitleChangedRef: hasTitleChangedRef, hasTitleSuggestionTriggeredRef: hasTitleSuggestionTriggeredRef, isSmartCreate: isSmartCreate })=>{
    const { contentAppearance: contentAppearance } = (0, $2HGN8.useContentAppearance)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isPageContentFullWidth = contentAppearance.appearance === 'full-width';
    const emojiStatusFieldName = (0, $5amrO.useEmojiStatusFieldName)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverview = homepageId === contentId;
    const { hideTitleToolbar: hideTitleToolbar } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showTitleToolbar = isEmbeddedConfluence ? !hideTitleToolbar : true;
    const { approvalRequest: approvalRequest, availableWorkflowStatuses: availableWorkflowStatuses } = (0, $laFNM.useApprovals)();
    const hasActiveWorkflowStatus = !!approvalRequest?.application?.workflowStatusId && availableWorkflowStatuses.some((s)=>s.id === approvalRequest.application.workflowStatusId) && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $lC6Qd.default), {
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "title-area-content-components"
    });
    const { data: emojiData, error: emojiError } = (0, $jMyy4.useQueryInterop)((0, $5DJsZ.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "title-area-content-components"
    });
    const shouldRenderStudioAutomationDiscovery = isLivePage && isRovoLLMEnabled && (0, $9wGTI.fg)('cc_automations_discovery_nudges');
    const { data: editorTitleAreaData } = (0, $jMyy4.useQueryInterop)((0, $dc42ee61ad89f7ea$export$2e2bcd8739ae039), {
        skip: !(0, $9wGTI.fg)('cc_automations_discovery_nudges'),
        variables: {
            contentId: contentId,
            cloudId: cloudId,
            includeStudioAutomationDiscovery: shouldRenderStudioAutomationDiscovery
        },
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        onError: (error)=>{
            if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error) && ((0, $1uFM6.isUnauthorizedError)(error) || error?.message.includes('Failed to fetch'))) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "title-area-content-components"
    });
    const hasDefaultTitleEmoji = isLivePage && (0, $8rneB.getHasLiveDocsDefaultEmoji)(emojiData);
    const hasEmojiFromQuery = !!(emojiData && ((0, $8rneB.getHasEmoji)(emojiData, emojiStatusFieldName) || hasDefaultTitleEmoji));
    const properties = data?.content?.nodes?.[0]?.properties?.nodes || []; // we only need the draft info since this will just be used to determine what component to show during edit mode
    const draft = properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
    const coverPictureInfo = (0, $3WPGR.propertyToId)(draft);
    const hasCoverPicture = !!coverPictureInfo?.value?.id;
    const isUnsplash = coverPictureInfo?.value?.id.includes('images.unsplash.com');
    const isGeneratingAIImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const aiCoverPictureInFlightRef = (0, $cozmU.useRef)(false); // Track when AI generation starts — keep it true until the cover picture is actually committed
    if (isGeneratingAIImage) aiCoverPictureInFlightRef.current = true;
     // Clear the in-flight flag once the cover picture is confirmed via GraphQL
    if (hasCoverPicture) aiCoverPictureInFlightRef.current = false;
     // Clear the in-flight flag for errors
    if (aiHeaderImageStatus === 'ERROR') aiCoverPictureInFlightRef.current = false;
     // Clear the in-flight flag if the AI cover picture failed to generate, no error
    if (!hasCoverPicture && !aiHeaderImageFileId && !isGeneratingAIImage && !coverPictureState.state.isUploadingPicture && aiHeaderImageStatus === 'NOT_LOADING') aiCoverPictureInFlightRef.current = false;
    const effectiveHasCoverPicture = hasCoverPicture || aiCoverPictureInFlightRef.current || coverPictureState.state.hasCoverPicture && (0, $9wGTI.fg)('confluence_cover_pic_optimistic_update_fallback');
    const isLiveDoc = (0, $3jwuS.useIsCurrentPageLive)();
    const isNativeEmbed = !!(0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search));
    const isInNativeEmbedLiveDoc = isNativeEmbed && isLiveDoc;
    (0, $cozmU.useEffect)(()=>{
        coverPictureState.setHasCoverPicture(hasCoverPicture);
    }, [
        hasCoverPicture,
        coverPictureState
    ]);
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const shouldRenderAboveTitle = !isTemplateEditor && showTitleToolbar && !isMarkdownMode;
    const shouldBylineRenderContentTopper = isLivePage || !isSpaceOverview;
    const isAgenticConfluenceAudience = isAdminHubAIEnabled && isAIEarlyAccessEnabled && isRovoLLMEnabled && ((0, $9wGTI.fg)('cc-ce-mau-discovery-agent-rec-from-page-title-gate') || (0, $9wGTI.fg)('cc-ce-mau-planner-agent-rec-from-page-title-gate') || (0, $9wGTI.fg)('post-office-tech-writer-nudges') || (0, $6mKj3.expValEquals)('confluece_ootb_title_based_contextual_nudge_exp', 'cohort', 'experiment'));
    const shouldRenderAgentTitleAreaBanner = isAgenticConfluenceAudience && contentType === 'page';
    const { loading: restrictionsLoading, restrictions: restrictions } = (0, $jLw6A.usePageRestrictionsContext)();
    const hasAnyRestrictions = !!(restrictions?.hasRestrictions || restrictions?.hasViewRestrictions || restrictions?.hasInheritedRestrictions); // Hide CopyWithRovo while restrictions are loading or unknown to avoid leaking
    // the affordance for restricted pages before data has resolved.
    const shouldRenderCopyWithRovo = !restrictionsLoading && !hasAnyRestrictions;
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, emojiError ? /*#__PURE__*/ $cozmU.createElement((0, $b3j2Y.ErrorDisplay), {
        error: emojiError
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer),
            (0, $bJX6u.ContentStateStateContainer),
            (0, $gektR.AlignmentButtonContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (emojiTitleState, contentStateState, alignmentButtonState, flags)=>{
        const hasEmoji = hasEmojiFromQuery || !!emojiTitleState.state.selectedEmoji;
        return /*#__PURE__*/ $cozmU.createElement((0, $kA6Zo.default), {
            direction: "column",
            xcss: [
                $371f4180811f666e$var$editorTitleBaseStyles,
                shouldBylineRenderContentTopper && $371f4180811f666e$var$editorTitleSmallerMarginBottomBaseStyles
            ]
        }, /*#__PURE__*/ $cozmU.createElement($371f4180811f666e$var$EditorTitleWithButtonsWrapper, {
            viewMode: !!viewMode,
            isContentTopperComponentPresent: !!contentTopperComponent,
            shouldBylineRenderContentTopper: shouldBylineRenderContentTopper,
            hasCoverPicture: effectiveHasCoverPicture,
            isInNativeEmbedLiveDoc: isInNativeEmbedLiveDoc
        }, shouldRenderAboveTitle ? /*#__PURE__*/ $cozmU.createElement((0, $9da45ee98b721761$export$1ba161aab679566b), {
            contentId: contentId,
            userOffline: userOffline,
            isUnpublishedDraft: isUnpublishedDraft,
            isTitleDisabled: isTitleDisabled,
            isAddHeaderImageButtonFocused: coverPictureState.state.isAddHeaderImageButtonFocused,
            isCoverPictureModalOpen: coverPictureState.state.isModalOpen,
            hasCoverPicture: effectiveHasCoverPicture,
            isUploadingPicture: coverPictureState.state.isUploadingPicture,
            setSelectedEmoji: emojiTitleState.setSelectedEmoji,
            onEmojiPickerLoaded: emojiTitleState.onEmojiPickerLoaded,
            isEmojiButtonFocused: emojiTitleState.state.isEmojiButtonFocused,
            onUpdateStartEmoji: emojiTitleState.onUpdateStart,
            onUpdateEndEmoji: emojiTitleState.onUpdateEnd,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            contentStateState: contentStateState,
            hasContentState: !!contentStateState.state.contentState || hasActiveWorkflowStatus,
            isSpaceOverview: isSpaceOverview,
            isTitleCenterAligned: isTitleCenterAligned,
            alignmentButtonState: alignmentButtonState,
            coverPictureState: coverPictureState,
            coverPictureWidth: coverPictureState.state.coverPictureWidth,
            isSecondEmojiPickerOpen: emojiTitleState.state.openSecondEmojiPicker,
            flags: flags,
            contentClassificationMetadata: contentClassificationMetadata,
            hasClassification: hasClassification,
            isReadOnly: viewMode,
            spaceKey: spaceKey,
            isEditorEmpty: isEditorEmpty,
            contentComponentsDisabled: contentComponentsDisabled,
            isDraftLockedForEditing: isDraftLockedForEditing,
            isStatusDisconnected: isStatusDisconnected,
            hasEmoji: hasEmoji,
            coverImageWidthCached: coverImageWidthCached,
            isUnsplash: isUnsplash,
            hideSuggestedTitle: hideSuggestedTitle,
            hideContentState: hideContentState,
            hideEditorAppearanceButton: hideEditorAppearanceButton,
            hideContentModeButton: hideContentModeButton,
            hideAlignmentButton: hideAlignmentButton,
            aiHeaderImageStatus: aiHeaderImageStatus,
            aiHeaderImageFileId: aiHeaderImageFileId,
            aiHeaderImageError: aiHeaderImageError,
            generateAIHeaderImage: generateAIHeaderImage,
            setAIHeaderImageStatus: setAIHeaderImageStatus,
            isSmartCreate: isSmartCreate,
            isAutoPageEmojiEligible: isAutoPageEmojiEligible,
            emojiTitleDiscovered: emojiTitleDiscovered,
            onSuggestTitleClickedRef: onSuggestTitleClickedRef
        }) : null, /*#__PURE__*/ $cozmU.createElement((0, $d765f449481d5188$export$718e92491c44b3f6), {
            editorTitle: editorTitle,
            contentTopperComponent: contentTopperComponent,
            contentId: contentId,
            isTemplateEditor: isTemplateEditor,
            onUpdateStartEmoji: emojiTitleState.onUpdateStart,
            onUpdateEndEmoji: emojiTitleState.onUpdateEnd,
            isTitleDisabled: isTitleDisabled,
            isTitleCenterAligned: isTitleCenterAligned,
            linkCreation: linkCreation,
            hasCoverPicture: effectiveHasCoverPicture,
            hasEmoji: hasEmoji,
            coverPictureWidth: coverPictureState.state.coverPictureWidth,
            isRemovingEmoji: emojiTitleState.state.isRemovingEmoji,
            isReadOnly: viewMode,
            contentClassificationMetadata: contentClassificationMetadata,
            isPageContentFullWidth: isPageContentFullWidth,
            hasClassification: hasClassification,
            isTitleAlignmentLoading: isTitleAlignmentLoading,
            isSpaceOverview: isSpaceOverview,
            pageTitleContent: pageTitleContent,
            isAutoPageEmojiEligible: isAutoPageEmojiEligible,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            emojiTitleDiscovered: emojiTitleDiscovered,
            contentType: contentType,
            isSmartCreate: isSmartCreate
        })), (0, $9wGTI.fg)('cc_fd_suggest_whiteboards_on_page_title_gate') || (0, $9wGTI.fg)('cc-fd-skill-rec-from-page-title-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate') || (0, $9wGTI.fg)('cc_automations_discovery_nudges') || isAgenticConfluenceAudience ? /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            xcss: $371f4180811f666e$var$authorBylinePositionRelative
        }, shouldBylineRenderContentTopper && contentTopperComponent && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            testId: "content-topper-wrapper",
            xcss: [
                isTitleCenterAligned && $371f4180811f666e$var$titleBoxStylesAlignSelfCenter
            ]
        }, contentTopperComponent), ((0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate')) && /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $06994e2bc47ea9f1$export$b80ef436249adad3), {
            spaceKey: spaceKey,
            contentId: contentId,
            title: title,
            titleAfterBlur: titleAfterBlur,
            isLivePage: isLivePage,
            isUnpublishedDraft: isUnpublishedDraft,
            version: version
        })), shouldRenderStudioAutomationDiscovery && /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: editorTitleAreaData?.singleContent?.meetingNotesAutomationDiscovery,
            postOfficePlacementId: "confluence-editor-title-area-banner"
        })), shouldRenderAgentTitleAreaBanner && /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $bba9d309d79f14df$export$324976fee0b64395), {
            spaceKey: spaceKey,
            contentId: contentId,
            title: titleAfterBlur ?? title,
            isLivePage: isLivePage,
            isUnpublishedDraft: isUnpublishedDraft,
            version: version,
            hasTitleChangedRef: hasTitleSuggestionTriggeredRef
        })), !shouldRenderAgentTitleAreaBanner && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $1c4544a2fa66a7a2$export$e8e7631381a283f), {
            spaceKey: spaceKey,
            contentId: contentId,
            title: title,
            titleAfterBlur: titleAfterBlur,
            isLivePage: isLivePage,
            isUnpublishedDraft: isUnpublishedDraft,
            version: version,
            hasTitleChangedRef: hasTitleChangedRef
        })), (0, $9wGTI.fg)('cc-fd-skill-rec-from-page-title-gate') && /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            appear: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $6981bbd475ce8ca7$export$20f99fd00736b20), {
            spaceKey: spaceKey,
            contentId: contentId,
            title: title,
            titleAfterBlur: titleAfterBlur,
            isLivePage: isLivePage,
            isUnpublishedDraft: isUnpublishedDraft,
            version: version,
            hasTitleChangedRef: hasTitleChangedRef
        })))) : shouldBylineRenderContentTopper && contentTopperComponent && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
            testId: "content-topper-wrapper",
            xcss: [
                isTitleCenterAligned && $371f4180811f666e$var$titleBoxStylesAlignSelfCenter
            ]
        }, contentTopperComponent), shouldRenderCopyWithRovo && (0, $6mKj3.expVal)('cc_fd_copy_with_rovo_gate', 'isEnabled', false) && /*#__PURE__*/ $cozmU.createElement((0, $8154f88738818571$export$f935dade49f9740), {
            contentId: contentId
        }));
    }));
};
$371f4180811f666e$export$860ceec1bc73beeb.displayName = 'EditorTitleWithTitleAreaComponents';
module.exports["EditorTitleWithTitleAreaComponents"] = $371f4180811f666e$export$860ceec1bc73beeb;

});

parcelRegister("d4IMD", function(module, exports) {

let $984e631e100ba261$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $984e631e100ba261$var$load("7EorR"),
    $984e631e100ba261$var$load("azRd4"),
    $984e631e100ba261$var$load("htt5m")
]).then(()=>parcelRequire('6tEA6'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bYkJQ", function(module, exports) {

let $8b756289ba00f54a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8b756289ba00f54a$var$load("iGaRG"),
    $8b756289ba00f54a$var$load("kJ1vX"),
    $8b756289ba00f54a$var$load("eShF9"),
    $8b756289ba00f54a$var$load("6wr18"),
    $8b756289ba00f54a$var$load("4nZ85"),
    $8b756289ba00f54a$var$load("kHXvF"),
    $8b756289ba00f54a$var$load("iWnyc"),
    $8b756289ba00f54a$var$load("ffEVr"),
    $8b756289ba00f54a$var$load("excC5"),
    $8b756289ba00f54a$var$load("hhss7"),
    $8b756289ba00f54a$var$load("Wowvf"),
    $8b756289ba00f54a$var$load("lkxmG"),
    $8b756289ba00f54a$var$load("7EorR"),
    $8b756289ba00f54a$var$load("f88d4")
]).then(()=>parcelRequire('33GvD'));

});

parcelRegister("fLt7u", function(module, exports) {

let $b7a1d5674efed6a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b7a1d5674efed6a2$var$load("iGaRG"),
    $b7a1d5674efed6a2$var$load("kJ1vX"),
    $b7a1d5674efed6a2$var$load("6wr18"),
    $b7a1d5674efed6a2$var$load("4nZ85"),
    $b7a1d5674efed6a2$var$load("5k22f"),
    $b7a1d5674efed6a2$var$load("kHXvF"),
    $b7a1d5674efed6a2$var$load("iWnyc"),
    $b7a1d5674efed6a2$var$load("ffEVr"),
    $b7a1d5674efed6a2$var$load("dMxTK"),
    $b7a1d5674efed6a2$var$load("cL90P"),
    $b7a1d5674efed6a2$var$load("fob67"),
    $b7a1d5674efed6a2$var$load("hhss7"),
    $b7a1d5674efed6a2$var$load("Wowvf"),
    $b7a1d5674efed6a2$var$load("lkxmG"),
    $b7a1d5674efed6a2$var$load("7EorR"),
    $b7a1d5674efed6a2$var$load("25DGt")
]).then(()=>parcelRequire('8r467'));

});

parcelRegister("fpvDE", function(module, exports) {

let $b381bb907617c7ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b381bb907617c7ab$var$load("iGaRG"),
    $b381bb907617c7ab$var$load("kJ1vX"),
    $b381bb907617c7ab$var$load("6wr18"),
    $b381bb907617c7ab$var$load("7EorR"),
    $b381bb907617c7ab$var$load("jqoep"),
    $b381bb907617c7ab$var$load("ffEVr"),
    $b381bb907617c7ab$var$load("coeRG")
]).then(()=>parcelRequire('joxlR'));

});

parcelRegister("dwWZ5", function(module, exports) {

let $9d9c04948252c26b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d9c04948252c26b$var$load("fq1gG"),
    $9d9c04948252c26b$var$load("6wr18"),
    $9d9c04948252c26b$var$load("ffEVr"),
    $9d9c04948252c26b$var$load("dMxTK"),
    $9d9c04948252c26b$var$load("cL90P"),
    $9d9c04948252c26b$var$load("fob67"),
    $9d9c04948252c26b$var$load("b1nSj")
]).then(()=>parcelRequire('1PKC4'));

});


//# sourceMappingURL=TitleAreaContentComponents.2457298d.js.map
